/*
  Pricer configurator — CIRCULAR variant, for Custom Circular Stencils.

  GENERATED FILE — do not hand-edit. Built from assets/pricer-v2.js by
    scratchpad/build-circle-pricer.js; change v2 (or the script) and re-run.

  Colin: "exact same as the live version except the crop is a circle/oval."
  The only functional differences from pricer-v2.js are marked CIRCULAR:
    - custom element <pricer-app-circle>, so both can coexist
    - proportions start LOCKED (12 x 12 = a perfect circle); unlocking
      lets the customer reshape into an oval
    - the crop is the ellipse inscribed in the dragged box: the on-page
      frame (CSS), the review modal (CSS), the review thumbnail, the
      cropped PNG sent to the designers, and the designer SVG frame layer
    - the person-for-scale figure holds the circle/oval

  Original v2 header follows.

  Pricer configurator — v2 flow (2026-08-20).

  WHAT CHANGED FROM v1: only the interaction layer. This is a four-step wizard
  (Upload → Size → Qty → Details) rendering one card at a time, built from
  Colin's prototype (pricer-flow-prototype-v2.html). Crop moved out of its modal
  and into the Size step, directly under the dimension controls, so framing and
  sizing happen together with the lock button deciding which one drives.

  WHAT DID NOT CHANGE, and must not be casually rewritten — every one of these
  was found the hard way against the live store:
    - handleAddToCart's variant-propagation retry loop. A variant created
      moments earlier through the Admin API can still be invisible to the
      Storefront cart ("Cannot find variant"); Admin-side confirmation does not
      mean Storefront-side readiness, so the retry against the real cart
      endpoint is the only thing that can observe when it's safe. Six attempts,
      1s doubling to 5s.
    - the 45s failsafe that re-enables the button. Without it a customer whose
      cart events never fire is left with a permanently dead button.
    - _artworkReady. Add to Cart awaits any in-flight cropped-render rebuild, so
      a fast click can't submit before the cropped PNG is attached.
    - the 20MB line-item-property cap, surfaced at the upload control itself.
    - pdf.js for PDF and .ai, loaded lazily on first use.
    - the no-preview acknowledgement gate for files we can't rasterise.

  PRICING: real numbers from Colin's spreadsheet in assets/pricer-real-data.js
  (base $55.99 + the base-adder table + the quantity table). Loaded before this
  file by whichever of snippets/product-info.liquid or sections/pricer.liquid
  mounts the configurator.

  PRICING BACKEND: Add to Cart calls the stencil-pricer-backend app's
  /apps/pricer/quote endpoint through Shopify's app proxy to get a variant
  priced exactly right for the chosen width/height/qty, then submits THAT
  variant instead of the product's base one — this is what makes the price
  charged match the price shown. Requires that app installed on the store; if
  it isn't, the fetch fails and Add to Cart is correctly blocked rather than
  silently charging the wrong price.
*/
(function () {
  if (customElements.get('pricer-app-circle')) return;

  var DATA = window.PRICER_REAL_DATA;

  /* CIRCULAR: clip a canvas to the ellipse inscribed in it. */
  function clipEllipse(ctx, w, h){
    ctx.beginPath();
    ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
    ctx.clip();
  }
  var MAX_REAL_QTY = 1005; // last non-sentinel row in the quantity-discount table
  var MIN_DIM = 2;  // the pricing table starts at 2" — confirmed with Colin, 2026-08-19
  var MAX_DIM = 48; // the table's real ceiling (rows/cols 49 are degenerate sentinels)
  var MAX_QTY = 500;
  /* Where the 48" ceiling sends customers who need bigger. The live handle —
     `large-custom-stencils` 404s. */
  var LARGE_URL = '/products/large-custom-mylar-stencils';

  function baseAdderFor(width, height){
    var w = Math.min(MAX_DIM, Math.max(MIN_DIM, Math.round(width)));
    var h = Math.min(MAX_DIM, Math.max(MIN_DIM, Math.round(height)));
    return DATA.baseAdders[h - 2][w - 2];
  }
  function qtyColFor(area){
    var headers = DATA.qtyHeaders;
    var col = 0;
    for (var i = 0; i < headers.length - 1; i++) { // exclude the trailing 9999 sentinel column
      if (headers[i] <= area) col = i;
    }
    return col;
  }
  function qtyAddFor(q, col){
    var labels = DATA.qtyLabels;
    var table = DATA.qtyDiscount;
    var qty = Math.min(MAX_REAL_QTY, Math.max(1, q));
    var exact = labels.indexOf(qty);
    if (exact !== -1) return table[exact][col];
    // Not every quantity has its own row past 100 (steps of 5) — interpolate
    // linearly between the two nearest real rows for a smooth in-between price.
    for (var i = 0; i < labels.length - 1; i++) {
      if (labels[i] < qty && qty < labels[i + 1] && labels[i + 1] <= MAX_REAL_QTY) {
        var t = (qty - labels[i]) / (labels[i + 1] - labels[i]);
        return table[i][col] + t * (table[i + 1][col] - table[i][col]);
      }
    }
    return table[labels.indexOf(MAX_REAL_QTY)][col];
  }
  function quote(w, h, q){
    if (!w || !h) return null;
    var area = w * h;
    var total0 = DATA.base + baseAdderFor(w, h);
    var total = total0 + qtyAddFor(q, qtyColFor(area));
    var unit = Math.round((total / q) * 100) / 100;
    return { unit: unit, total: unit * q, single: Math.round(total0 * 100) / 100 };
  }

  /* The pricing tables are in the shop's own currency, but a visitor may be
     browsing in another one — Shopify converts at the cart. Showing a hardcoded
     "$" meant a customer on, say, PHP saw "$416.01" here and a peso total at
     checkout. Convert and format with the active currency instead, falling back
     to the old behaviour if the storefront doesn't expose one. */
  function money(n){
    var c = window.Shopify && window.Shopify.currency;
    var rate = c && parseFloat(c.rate);
    var code = c && c.active;
    if (!code || !rate || !isFinite(rate)) return '$' + n.toFixed(2);
    var converted = n * rate;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code
      }).format(converted);
    } catch (e) {
      return converted.toFixed(2) + ' ' + code;
    }
  }

  function snap4(n){ return Math.round(n * 4) / 4; }   // stencils are cut to the quarter inch
  function clampDim(v){ return Math.min(MAX_DIM, Math.max(MIN_DIM, v)); }
  function fmtDim(v){ return String(Math.round(v * 100) / 100); }
  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ==================================================================
     SIZE DIMENSIONS — shared drawing helpers (Colin, 2026-10-12)
     Used by the new size preview modal on the Review step.
     Pure functions: numbers in, SVG markup out.
  ================================================================== */

  /* The Size step tells customers "We add a 1" border on each side around
     your design" — state.w × state.h is the DESIGN area, and the stencil
     they receive is that plus the border. One constant, so if the border
     ever changes the copy and both drawings move together. */
  var BORDER_IN = 1;

  function stencilDims(w, h){
    return { w: w + 2 * BORDER_IN, h: h + 2 * BORDER_IN };
  }

  /* YOUR DESIGN, drawn as letter shapes rather than live font text, so the
     lettering's outer edges ARE the design area — exactly bw × bh, centred
     on (cx, cy). Font text can't do this: a font's box includes empty space
     above and below the capitals, so the words never quite reach the edges.
     Deliberately NOT the customer's artwork — this shows the design SIZE,
     not a proof.

     Laid out one of four ways — one line, stacked on two lines, or either
     turned on its side for tall stencils — whichever is closest in shape to
     the design area, then stretched to fill it edge to edge. */
  /* ATK Studio "Elios" (Colin's licensed copy), letters Y O U R D E S I G N
     only, converted to outlines: each is 100 tall and 63 wide on a 85
     advance, so the font itself is never loaded on the site. */
  var YD_GLYPHS = {
    Y: 'M54.3 0.3L60.9 0.3Q61.8 0.3 62.4 0.9Q63 1.5 63 2.3L63 26.4Q63 30.8 60.2 33.5L38.3 57.2Q36.8 58.7 36.8 60.6L36.8 97.6Q36.8 98.4 36.3 99Q35.7 99.6 34.9 99.6L28.2 99.6Q27.4 99.6 26.8 99Q26.2 98.4 26.2 97.6L26.2 56.4Q26.2 54.4 27.6 53L50.9 27.8Q52.3 26.5 52.3 24.4L52.3 2.3Q52.3 1.5 52.9 0.9Q53.5 0.3 54.3 0.3ZM1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3L10.6 24.4Q10.6 26.4 12 27.8L26.9 44Q27.6 44.7 27.6 45.4Q27.6 46.1 26.9 46.8L22.5 51.7Q22 52.2 21.1 52.2Q20.2 52.2 19.7 51.7L2.7 33.5Q0 30.8 0 26.4L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3Z',
    O: 'M29.2 91.2L29.2 97.9Q29.2 98.7 28.7 99.2Q28.3 99.7 27.5 99.7L27.2 99.7Q15.7 98.1 7.8 89.2Q0 80.2 0 68.5L0 31.4Q0 19.5 7.8 10.6Q15.7 1.7 27.2 0.1L27.5 0.1Q29.2 0.1 29.2 1.9L29.2 8.7Q29.2 9.5 28.6 10.1Q28 10.7 27.2 10.9Q20 12.5 15.3 18.2Q10.6 23.9 10.6 31.4L10.6 68.5Q10.6 75.8 15.3 81.6Q20 87.3 27.2 88.9Q28 89.1 28.6 89.8Q29.2 90.4 29.2 91.2ZM33.9 8.7L33.9 1.9Q33.9 0.1 35.6 0.1L35.9 0.1Q47.4 1.7 55.2 10.7Q63 19.6 63 31.4L63 68.5Q63 80.2 55.1 89.2Q47.3 98.1 35.9 99.7L35.6 99.7Q34.8 99.7 34.3 99.2Q33.9 98.7 33.9 97.9L33.9 91.2Q33.9 90.4 34.5 89.8Q35 89.1 35.9 88.9Q42.9 87.3 47.6 81.6Q52.3 75.8 52.3 68.5L52.3 31.4Q52.3 23.9 47.6 18.2Q42.9 12.5 35.9 10.9Q35 10.7 34.5 10.1Q33.9 9.5 33.9 8.7Z',
    U: 'M29.2 91.2L29.2 97.9Q29.2 98.7 28.7 99.2Q28.3 99.7 27.5 99.7L27.2 99.7Q19.7 99.7 13.4 95.2Q7.1 90.7 3.5 83.5Q0 76.3 0 68.5L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3L10.6 68.5Q10.6 75.8 15.3 81.6Q20 87.3 27.2 88.9Q28 89.1 28.6 89.8Q29.2 90.4 29.2 91.2ZM54.3 0.3L60.9 0.3Q61.8 0.3 62.4 0.9Q63 1.5 63 2.3L63 68.5Q63 80.2 55.1 89.2Q47.3 98.1 35.9 99.7L35.6 99.7Q34.8 99.7 34.3 99.2Q33.9 98.7 33.9 97.9L33.9 91.2Q33.9 90.4 34.5 89.8Q35 89.1 35.9 88.9Q42.9 87.3 47.6 81.6Q52.3 75.8 52.3 68.5L52.3 2.3Q52.3 1.5 52.9 0.9Q53.5 0.3 54.3 0.3Z',
    R: 'M8.7 99.6L1.9 99.6Q1.1 99.6 0.6 99Q0 98.4 0 97.6L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3L10.6 97.6Q10.6 98.4 10 99Q9.5 99.6 8.7 99.6ZM42.4 56.4L62.1 97.7Q62.4 98.3 62.4 98.6Q62.4 99.6 60.9 99.6L53.2 99.6Q51.2 99.6 50.3 97.7L30.9 57.1Q29.9 55.2 28 55.2L17.3 55.2Q16.5 55.2 15.9 54.6Q15.3 54 15.3 53.2L15.3 46.5Q15.3 45.7 15.9 45.1Q16.5 44.5 17.3 44.5L35.6 44.5Q42.5 44.5 47.4 39.6Q52.3 34.8 52.3 27.8Q52.3 20.9 47.4 15.9Q42.5 10.9 35.6 10.9L17.3 10.9Q16.5 10.9 15.9 10.4Q15.3 9.8 15.3 8.9L15.3 2.3Q15.3 1.5 15.9 0.9Q16.5 0.3 17.3 0.3L35.6 0.3Q46.9 0.3 54.9 8.4Q63 16.5 63 27.8Q63 37 57.5 44.2Q52 51.4 43.5 54.1Q42.1 54.6 42.1 55.6Q42.1 55.9 42.4 56.4Z',
    D: 'M10.6 2.3L10.6 97.6Q10.6 98.4 10 99Q9.5 99.6 8.7 99.6L1.9 99.6Q1.1 99.6 0.6 99Q0 98.4 0 97.6L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3ZM31.4 99.6L17.3 99.6Q16.5 99.6 15.9 99Q15.3 98.4 15.3 97.6L15.3 90.9Q15.3 90.1 15.9 89.5Q16.5 88.9 17.3 88.9L31.4 88.9Q40 88.9 46.2 82.8Q52.3 76.7 52.3 68.1L52.3 31.8Q52.3 23.1 46.2 17Q40 10.9 31.4 10.9L17.3 10.9Q16.5 10.9 15.9 10.4Q15.3 9.8 15.3 8.9L15.3 2.3Q15.3 1.5 15.9 0.9Q16.5 0.3 17.3 0.3L31.4 0.3Q37.8 0.3 43.7 2.8Q49.5 5.3 53.7 9.5Q58 13.7 60.5 19.6Q63 25.4 63 31.8L63 68.1Q63 74.4 60.5 80.3Q58 86.1 53.7 90.4Q49.5 94.6 43.7 97.1Q37.8 99.6 31.4 99.6Z',
    E: 'M15.3 8.9L15.3 2.3Q15.3 1.5 15.9 0.9Q16.5 0.3 17.3 0.3L60.9 0.3Q61.8 0.3 62.4 0.9Q63 1.5 63 2.3L63 8.9Q63 9.8 62.4 10.4Q61.8 10.9 60.9 10.9L17.3 10.9Q16.5 10.9 15.9 10.4Q15.3 9.8 15.3 8.9ZM1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3L10.6 42.7Q10.6 43.6 11.2 44.1Q11.8 44.7 12.6 44.7L54.4 44.7Q55.3 44.7 55.9 45.3Q56.4 45.8 56.4 46.7L56.4 53.3Q56.4 54.2 55.9 54.7Q55.3 55.3 54.4 55.3L12.6 55.3Q11.8 55.3 11.2 55.9Q10.6 56.5 10.6 57.3L10.6 97.6Q10.6 98.4 10 99Q9.5 99.6 8.7 99.6L1.9 99.6Q1.1 99.6 0.6 99Q0 98.4 0 97.6L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3ZM15.3 97.6L15.3 90.9Q15.3 90.1 15.9 89.5Q16.5 88.9 17.3 88.9L60.9 88.9Q61.8 88.9 62.4 89.5Q63 90.1 63 90.9L63 97.6Q63 98.4 62.4 99Q61.8 99.6 60.9 99.6L17.3 99.6Q16.5 99.6 15.9 99Q15.3 98.4 15.3 97.6Z',
    S: 'M29.2 2L29.2 8.8Q29.2 9.6 28.6 10.2Q28 10.8 27.2 10.8Q20.4 10.8 15.5 15.8Q10.7 20.8 10.7 27.7Q10.7 29.7 11.1 31.4Q11.6 33.1 12.6 34.5Q13.6 35.8 14.6 36.9Q15.6 38 17.4 38.9Q19.3 39.9 20.6 40.5Q22 41.2 24.4 41.9Q26.9 42.7 28.4 43.1Q30 43.6 32.8 44.3Q36.8 45.3 39 45.9Q41.2 46.5 44.9 47.9Q48.5 49.2 50.7 50.5Q52.8 51.8 55.5 54Q58.1 56.2 59.5 58.7Q60.9 61.1 61.9 64.6Q63 68.1 63 72.4Q63 83.8 55 91.9Q47.1 100 35.9 100Q35 100 34.5 99.4Q33.9 98.8 33.9 98L33.9 91.2Q33.9 90.4 34.4 89.8Q35 89.2 35.9 89.2Q42.6 89.2 47.4 84.2Q52.3 79.2 52.3 72.4Q52.3 69.8 51.6 67.6Q50.8 65.4 49.9 63.9Q48.9 62.4 46.9 61Q44.9 59.6 43.4 58.8Q41.8 57.9 38.9 57Q36 56 34.2 55.5Q32.4 55.1 29.1 54.2Q26.3 53.5 24.8 53.2Q23.3 52.8 20.7 52Q18.1 51.3 16.6 50.7Q15.1 50 12.8 49Q10.5 48.1 9.2 47Q7.9 45.9 6.2 44.5Q4.6 43.1 3.6 41.4Q2.6 39.7 1.7 37.6Q0.8 35.6 0.4 33.1Q0 30.5 0 27.7Q0 16.5 8 8.2Q16 0 27.2 0Q28 0 28.6 0.6Q29.2 1.2 29.2 2ZM35.9 10.8Q35 10.8 34.4 10.2Q33.9 9.6 33.9 8.8L33.9 2Q33.9 1.2 34.5 0.6Q35 0 35.9 0Q47 0 55 8.1Q63 16.2 63 27.4Q63 28.3 62.4 28.8Q61.8 29.4 60.9 29.4L54.3 29.4Q53.5 29.4 52.9 28.8Q52.3 28.3 52.3 27.4Q52.3 20.7 47.4 15.8Q42.5 10.8 35.9 10.8ZM29.2 91.2L29.2 98Q29.2 98.8 28.6 99.4Q28 100 27.2 100Q16.1 100 8 92Q0 83.9 0 72.8Q0 72 0.6 71.4Q1.1 70.8 1.9 70.8L8.8 70.8Q9.6 70.8 10.2 71.4Q10.7 72 10.7 72.8Q10.7 79.6 15.6 84.4Q20.4 89.2 27.2 89.2Q28 89.2 28.6 89.8Q29.2 90.4 29.2 91.2Z',
    I: 'M1.9 0.3L60.9 0.3Q61.8 0.3 62.4 0.9Q63 1.5 63 2.3L63 8.9Q63 9.8 62.4 10.4Q61.8 10.9 60.9 10.9L1.9 10.9Q1.1 10.9 0.6 10.4Q0 9.8 0 8.9L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3ZM26.2 82.3L26.2 17.6Q26.2 16.8 26.8 16.2Q27.4 15.7 28.2 15.7L34.9 15.7Q35.7 15.7 36.3 16.2Q36.8 16.8 36.8 17.6L36.8 82.3Q36.8 83.1 36.3 83.7Q35.7 84.3 34.9 84.3L28.2 84.3Q27.4 84.3 26.8 83.7Q26.2 83.1 26.2 82.3ZM1.9 88.9L60.9 88.9Q61.8 88.9 62.4 89.5Q63 90.1 63 90.9L63 97.6Q63 98.4 62.4 99Q61.8 99.6 60.9 99.6L1.9 99.6Q1.1 99.6 0.6 99Q0 98.4 0 97.6L0 90.9Q0 90.1 0.6 89.5Q1.1 88.9 1.9 88.9Z',
    G: 'M33.9 8.8L33.9 2Q33.9 1.2 34.3 0.7Q34.8 0.1 35.6 0.1L35.9 0.1Q44.4 0.1 51.4 6.3Q58.4 12.5 61.4 21.5Q61.6 21.7 61.6 22.2Q61.6 23.3 60 23.8L53.6 25.6Q53.2 25.7 52.9 25.7Q51.5 25.7 51 24.3Q49.1 19.3 45 15.7Q41 12.1 35.9 11.1Q35 10.9 34.5 10.2Q33.9 9.6 33.9 8.8ZM29.2 2L29.2 8.8Q29.2 9.6 28.6 10.2Q28 10.9 27.2 11.1Q20 12.6 15.3 18.3Q10.6 24 10.6 31.5L10.6 68.7Q10.6 76 15.3 81.8Q20 87.5 27.2 89.1Q28 89.3 28.6 89.9Q29.2 90.5 29.2 91.3L29.2 98Q29.2 98.8 28.7 99.3Q28.3 99.9 27.5 99.9L27.2 99.9Q19.7 99.9 13.4 95.4Q7.1 90.9 3.5 83.7Q0 76.5 0 68.7L0 31.5Q0 23.6 3.5 16.4Q7.1 9.3 13.4 4.8Q19.7 0.3 27.2 0.3L27.5 0.3Q29.2 0.3 29.2 2ZM33.9 98L33.9 91.3Q33.9 90.5 34.5 89.9Q35 89.3 35.9 89.1Q42.9 87.4 47.6 81.7Q52.3 76 52.3 68.7L52.3 57.3Q52.3 56.5 51.7 55.9Q51.2 55.3 50.3 55.3L35.9 55.3Q35 55.3 34.5 54.7Q33.9 54.2 33.9 53.3L33.9 46.7Q33.9 45.8 34.5 45.3Q35 44.7 35.9 44.7L60.9 44.7Q61.8 44.7 62.4 45.3Q63 45.8 63 46.7L63 68.7Q63 76.5 59.4 83.7Q55.9 90.9 49.6 95.4Q43.3 99.9 35.9 99.9L35.6 99.9Q34.8 99.9 34.3 99.3Q33.9 98.8 33.9 98Z',
    N: 'M52.3 97.6L52.3 2.3Q52.3 1.5 52.9 0.9Q53.5 0.3 54.3 0.3L60.9 0.3Q61.8 0.3 62.4 0.9Q63 1.5 63 2.3L63 97.6Q63 98.4 62.4 99Q61.8 99.6 60.9 99.6L54.3 99.6Q53.5 99.6 52.9 99Q52.3 98.4 52.3 97.6ZM0 97.6L0 2.3Q0 1.5 0.6 0.9Q1.1 0.3 1.9 0.3L8.7 0.3Q9.5 0.3 10 0.9Q10.6 1.5 10.6 2.3L10.6 97.6Q10.6 98.4 10 99Q9.5 99.6 8.7 99.6L1.9 99.6Q1.1 99.6 0.6 99Q0 98.4 0 97.6ZM15.3 21L15.3 8.1Q15.3 7.1 15.7 7.1Q16.2 7.1 16.6 7.7L46.3 44.5Q47.6 46.4 47.6 48.1L47.6 61Q47.6 62 47.2 62Q46.7 62 46.3 61.4L16.6 24.6Q15.3 22.9 15.3 21Z'
  };
  var YD_W = 63, YD_GAP = 22.1, YD_LEAD = 22;

  /* One line of letters, `width` wide (natural when omitted). A short line
     widened to match a longer one (YOUR over DESIGN) splits the difference:
     the letters widen by the square root of the stretch and the gaps take
     the rest, so it neither balloons nor spreads into Y O U R. */
  function ydLine(word, width){
    var n = word.length;
    var natural = n * YD_W + (n - 1) * YD_GAP;
    var f = width ? Math.sqrt(width / natural) : 1;
    var cell = YD_W * f;
    var gap = (width && n > 1) ? (width - n * cell) / (n - 1) : YD_GAP;
    var d = '';
    for (var i = 0; i < n; i++) {
      var g = YD_GLYPHS[word.charAt(i)];
      if (!g) continue;                       // a space is just an empty cell
      var x = i * (cell + gap);
      /* Offset (and widen) the path data itself, not a per-letter transform,
         so a line stays one path — fewer nodes on every redraw. */
      d += g.replace(/([MLQ])([^MLQZ]*)/g, function (m, cmd, args) {
        var a = args.trim().split(/[ ,]+/).map(Number);
        for (var j = 0; j < a.length; j += 2) a[j] = Math.round((a[j] * f + x) * 10) / 10;
        return cmd + a.join(' ');
      });
    }
    return { w: width || natural, d: d };
  }

  function yourDesignSvg(cx, cy, bw, bh, o){
    o = o || {};
    if (!(bw > 0) || !(bh > 0)) return '';
    var one = ydLine('YOUR DESIGN'), bot = ydLine('DESIGN'), top = ydLine('YOUR', bot.w);
    var layouts = [
      { w: one.w, h: 100, kind: 'one' },
      { w: bot.w, h: 200 + YD_LEAD, kind: 'stack' }
    ];
    var best = null;
    [false, true].forEach(function (rot) {
      var target = rot ? bh / bw : bw / bh;
      layouts.forEach(function (l) {
        /* How far it has to stretch, as a ratio either way. Turning the words
           on their side has to win clearly, since it's harder to read. */
        var cost = Math.abs(Math.log(target / (l.w / l.h))) + (rot ? 0.6 : 0);
        if (!best || cost < best.cost) best = { l: l, rot: rot, cost: cost };
      });
    });
    var l = best.l, L = best.rot ? bh : bw, T = best.rot ? bw : bh;
    var paths = l.kind === 'one' ? '<path d="' + one.d + '"/>'
      : '<path d="' + top.d + '"/><path transform="translate(0 ' + (100 + YD_LEAD) + ')" d="' + bot.d + '"/>';
    return '<g transform="translate(' + cx + ' ' + cy + ')' + (best.rot ? ' rotate(-90)' : '') +
        ' scale(' + (L / l.w) + ' ' + (T / l.h) + ') translate(' + (-l.w / 2) + ' ' + (-l.h / 2) + ')"' +
        /* The outline is painted BEHIND the fill (paint-order) with round
           joins, so only its outer half shows: the yellow keeps its own clean
           edge, sharp corners don't spike, and thin bridges don't fill in. */
        ' fill="' + (o.fill || '#FFDE1B') + '" stroke="#141414" stroke-width="' + (o.stroke || 2.5) + '"' +
        ' stroke-linejoin="round" stroke-linecap="round" paint-order="stroke" shape-rendering="geometricPrecision">' +
      paths.replace(/<path /g, '<path vector-effect="non-scaling-stroke" ') + '</g>';
  }

  /* How thick the border is DRAWN. Never less than the true 1", but on big
     stencils the true border is a sliver next to the design (50" wide, 1"
     border) and customers couldn't see the difference between design size
     and stencil size. So it's drawn at least `share` of the stencil's
     shorter side. The labels always carry the real numbers. */
  function drawnBorder(trueB, sw, sh, share, floor){
    return Math.max(trueB, Math.min(sw, sh) * share, floor || 0);
  }

  /* A dimension label as a pill. kind: 'stencil' (black, outside size) or
     'design' (yellow, design area) — the same two colours as the legend. */
  function dimPill(x, y, text, fs, anchor, kind){
    var w = text.length * fs * 0.6 + fs * 1.1, h = fs * 1.55;
    var left = anchor === 'start' ? x : anchor === 'end' ? x - w : x - w / 2;
    var bg = kind === 'design' ? '#FFDE1B' : '#141414';
    return '<rect x="' + left + '" y="' + (y - h / 2) + '" width="' + w + '" height="' + h + '" rx="' + (h / 2) +
        '" fill="' + bg + '" stroke="#141414" stroke-width="1.5"/>' +
      '<text class="pricer-dimtxt" x="' + (left + w / 2) + '" y="' + (y + fs * 0.36) + '" font-size="' + fs +
        '" text-anchor="middle" fill="' + (kind === 'stencil' ? '#ffffff' : '#141414') + '">' + text + '</text>';
  }
  function dimH(x1, x2, y, text, fs, kind){
    return '<path d="M' + x1 + ',' + y + 'H' + x2 + 'M' + x1 + ',' + (y - 4) + 'v8M' + x2 + ',' + (y - 4) + 'v8"' +
        ' stroke="#141414" stroke-width="1.25" fill="none"/>' +
      dimPill((x1 + x2) / 2, y, text, fs, 'middle', kind);
  }
  function dimV(y1, y2, x, text, fs, kind, side){
    return '<path d="M' + x + ',' + y1 + 'V' + y2 + 'M' + (x - 4) + ',' + y1 + 'h8M' + (x - 4) + ',' + y2 + 'h8"' +
        ' stroke="#141414" stroke-width="1.25" fill="none"/>' +
      dimPill(side === 'left' ? x - 5 : x + 5, (y1 + y2) / 2, text, fs, side === 'left' ? 'end' : 'start', kind);
  }

  /* ---- Review step: size preview drawing ----
     Matches Colin's sketch: design width on top and design height on the
     left (yellow, with extension lines from the design area), stencil width
     on the bottom and stencil height on the right (black). */
  function stencilPreviewSvg(w, h){
    w = clampDim(w); h = clampDim(h);
    var o = stencilDims(w, h);
    var BOX = 300, k = BOX / Math.max(o.w, o.h);
    var sw = o.w * k, sh = o.h * k, b = drawnBorder(BORDER_IN * k, sw, sh, 0.14, 18);
    /* The 18 floor is wider than half a thin stencil: at 48 × 2 (sheet 300 × 24)
       it left the design area -12 tall, so no lettering and inverted brackets.
       Keep the drawn border to a quarter of the short side — never below the
       true 1", which is at most a quarter (the smallest stencil is 4"). */
    b = Math.min(b, Math.min(sw, sh) * 0.25);
    var ML = 84, MR = 84, MT = 44, MB = 44, FS = 12;
    var x = ML, y = MT, ix = x + b, iy = y + b, iw = sw - 2 * b, ih = sh - 2 * b;
    var ext = function (x1, y1, x2, y2, dashed) {
      return '<path d="M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2 + '" stroke="#8a877e" stroke-width="1"' +
        (dashed ? ' stroke-dasharray="3 3"' : '') + ' fill="none"/>';
    };
    return '<svg viewBox="0 0 ' + (sw + ML + MR) + ' ' + (sh + MT + MB) + '" xmlns="http://www.w3.org/2000/svg" role="img"' +
        ' aria-label="Stencil ' + fmtDim(o.w) + ' by ' + fmtDim(o.h) + ' inches, design area ' + fmtDim(w) + ' by ' + fmtDim(h) + ' inches">' +
      // the sheet, then the lettering filling the design area edge to edge
      '<rect x="' + x + '" y="' + y + '" width="' + sw + '" height="' + sh + '" rx="3" fill="#e4e1d8" stroke="#141414" stroke-width="2.5"/>' +
      yourDesignSvg(ix + iw / 2, iy + ih / 2, iw, ih) +
      // design area: top + left
      ext(ix, iy, ix, y - 26, true) + ext(ix + iw, iy, ix + iw, y - 26, true) +
      dimH(ix, ix + iw, y - 20, fmtDim(w) + '"', FS, 'design') +
      ext(ix, iy, x - 26, iy, true) + ext(ix, iy + ih, x - 26, iy + ih, true) +
      dimV(iy, iy + ih, x - 20, fmtDim(h) + '"', FS, 'design', 'left') +
      // outside of stencil: bottom + right
      ext(x, y + sh, x, y + sh + 26) + ext(x + sw, y + sh, x + sw, y + sh + 26) +
      dimH(x, x + sw, y + sh + 20, fmtDim(o.w) + '"', FS, 'stencil') +
      ext(x + sw, y, x + sw + 26, y) + ext(x + sw, y + sh, x + sw + 26, y + sh) +
      dimV(y, y + sh, x + sw + 20, fmtDim(o.h) + '"', FS, 'stencil', 'right') +
      '</svg>';
  }

  /* The modal is built on first use and appended to <body>, for the same
     reason as the crop-review modal: a transform on any ancestor breaks
     position:fixed. One shared node, reused on every open. */
  var sizeModal = null;
  function closeSizePreview(){
    if (!sizeModal || !sizeModal.classList.contains('show')) return false;
    sizeModal.classList.remove('show');
    document.body.classList.remove('pricer-lock');
    if (sizeModal._returnFocus) sizeModal._returnFocus.focus();
    return true;
  }
  function openSizePreview(w, h, opener){
    if (!sizeModal) {
      sizeModal = document.createElement('div');
      sizeModal.className = 'pricer-sizemodal';
      sizeModal.setAttribute('role', 'dialog');
      sizeModal.setAttribute('aria-modal', 'true');
      sizeModal.setAttribute('aria-label', 'Stencil size preview');
      sizeModal.innerHTML = '<div class="pricer-sizemodal__panel" tabindex="-1"></div>';
      sizeModal.addEventListener('click', function (e) {
        if (e.target === sizeModal || e.target.closest('[data-role="sizeClose"]')) closeSizePreview();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizePreview(); });
      document.body.appendChild(sizeModal);
    }
    w = clampDim(w); h = clampDim(h);
    var o = stencilDims(w, h);
    var panel = sizeModal.firstChild;
    panel.innerHTML =
      '<button type="button" class="pricer-sizemodal__x" data-role="sizeClose" aria-label="Close">✕</button>' +
      '<h3 class="pricer-sizemodal__h">Your stencil size</h3>' +
      '<div class="pricer-sizemodal__fig">' + stencilPreviewSvg(w, h) + '</div>' +
      '<div class="pricer-sizemodal__legend">' +
        '<span><i class="is-design"></i>Design area ' + fmtDim(w) + '" × ' + fmtDim(h) + '"</span>' +
        '<span><i class="is-stencil"></i>Stencil ' + fmtDim(o.w) + '" × ' + fmtDim(o.h) + '"</span>' +
      '</div>' +
      '<p class="pricer-sizemodal__note">Our team will send you a free design proof of your custom order before manufacturing.</p>';
    sizeModal._returnFocus = opener || null;
    sizeModal.classList.add('show');
    document.body.classList.add('pricer-lock');
    panel.focus();
  }

  /* Review step's Size row: design size with its Edit link, and under it
     the stencil's outside size as the button that opens the preview. */
  function sizeRowHtml(w, h){
    var o = stencilDims(clampDim(w), clampDim(h));
    return '<div class="row"><span class="k">Size</span><span class="pricer-sizeval">' +
      '<span>' + fmtDim(w) + '" × ' + fmtDim(h) + '" design' +
        '<button type="button" class="pricer-editlink" data-role="edSize">Edit</button></span>' +
      '<button type="button" class="pricer-sizelink" data-role="sizePreview" aria-haspopup="dialog">' +
        '<span>' + fmtDim(o.w) + '" × ' + fmtDim(o.h) + '" stencil · <u>Preview</u></span></button>' +
    '</span></div>';
  }

  var ATC_LABEL = 'Add to cart';

  /* Shopify's ceiling for a line-item property file upload. */
  var MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

  /* Ceiling for the embedded artwork inside the designer SVG. Base64 is ~1 byte
     per character, so this is effectively the finished file's size; the frame
     markup around it is under a kilobyte. Held well below MAX_UPLOAD_BYTES
     because the SVG is a THIRD attachment — the original and the cropped
     preview still have to fit in the same request. */
  var SVG_ARTWORK_BUDGET = 12 * 1024 * 1024;

  /* THE definition of "the artwork fits this size" — it asks the only question
     that matters: at the chosen width, does the artwork's own height come out
     as the height they ordered? Quarter-inch agreement (what snap4 rounds to,
     and the granularity these stencils are cut at) is the honest bar. */
  function fitsSize(artRatio, w, h){
    if (!artRatio || !w || !h) return false;
    return snap4(w / artRatio) === snap4(h);
  }

  /* .ai files usually contain a PDF stream (Illustrator's "Create PDF Compatible
     File", on by default), so PDF.js can render them too. Confirmed with Colin
     2026-08-19: AI yes, EPS no — EPS is PostScript and no browser can rasterise
     it, so it takes the no-preview path alongside PSD. Their MIME type is
     unreliable — often application/postscript or empty — hence the extension
     check alongside it. */
  function isPdfLike(f){
    var name = (f.name || '').toLowerCase();
    return f.type === 'application/pdf' || /\.(pdf|ai)$/.test(name);
  }

  var pdfJsPromise = null;
  function loadPdfJs(src, workerSrc){
    if (pdfJsPromise) return pdfJsPromise;
    pdfJsPromise = new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('pdf.js asset url missing')); return; }
      if (window.pdfjsLib) { resolve(window.pdfjsLib); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () {
        if (!window.pdfjsLib) { reject(new Error('pdf.js failed to define')); return; }
        if (workerSrc) window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
        resolve(window.pdfjsLib);
      };
      s.onerror = function () { reject(new Error('pdf.js failed to load')); };
      document.head.appendChild(s);
    });
    return pdfJsPromise;
  }

  var FILE_ICON = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56"><rect width="56" height="56" fill="%23FFDE1B"/><text x="28" y="34" font-size="12" text-anchor="middle" font-family="sans-serif" font-weight="bold">FILE</text></svg>';

  /* The quantity bands Colin's prototype shows on the Qty step. The BANDS are
     the design; the percentages are not hardcoded — each one is derived from the
     real pricing table at the current size (see tierPct), so the panel always
     tells the truth for the stencil being configured. */
  var QTY_TIERS = [
    { min: 1,  label: '1' },
    { min: 2,  label: '2–4' },
    { min: 5,  label: '5–9' },
    { min: 10, label: '10–24' },
    { min: 25, label: '25–49' },
    { min: 50, label: '50+' }
  ];
  function tierFor(q){
    var t = QTY_TIERS[0];
    for (var i = 0; i < QTY_TIERS.length; i++) { if (q >= QTY_TIERS[i].min) t = QTY_TIERS[i]; }
    return t;
  }
  function nextTier(q){
    for (var i = 0; i < QTY_TIERS.length; i++) { if (QTY_TIERS[i].min > q) return QTY_TIERS[i]; }
    return null;
  }
  /* Saving at a band's entry quantity, measured against the price of buying one
     — which is the comparison the customer is actually making. */
  function tierPct(w, h, minQty){
    var one = quote(w, h, 1);
    var at = quote(w, h, minQty);
    if (!one || !at || !one.unit) return 0;
    return Math.max(0, Math.round((1 - at.unit / one.unit) * 100));
  }

  var STEPS = ['Upload', 'Size', 'Qty', 'Details'];
  var STEP_LABEL = { Upload: 'Upload artwork', Size: 'Size it', Qty: 'Quantity', Details: 'Review' };
  /* Colin, 2026-10-12: the last step read "Review" on the Next button and
     "Details" on the progress bar. The bar now uses the button's word. Only the
     visible label changes — the step is still 'Details' everywhere in code. */
  var BAR_LABEL = { Details: 'Review' };

  /* Colin, 2026-09-04: a croppable upload moves itself on to Size rather than
     making the customer press Continue. The beat before it happens is on
     purpose — jumping the instant the image decodes swaps the card out from
     under the thumbnail that just appeared, so the upload reads as a glitch
     rather than as accepted. This lets that confirmation land first. Set to 0
     to advance immediately; see maybeAutoAdvance. */
  var AUTO_ADVANCE_MS = 450;

  /* How long an <img> decode is given before it is treated as never going to
     answer. Generous on purpose — this is a backstop for a decode that has hung
     outright, not a patience limit on a big file over a slow phone CPU, and
     finishing late still wins because the settle guard is first-past-the-post. */
  var DECODE_TIMEOUT_MS = 15000;

  /* The second-chance decode re-encodes through a canvas, and a canvas has a
     hard area ceiling on iOS (~16.7M px) above which it comes back blank. A
     modern phone camera sits just under that at full resolution and a 48MP one
     is well over, so the long edge is capped. This only ever applies to files
     that failed the normal decode and would otherwise have no preview at all —
     the customer's ORIGINAL file is attached to the order either way, so the
     cap costs a little preview resolution and never any artwork. */
  var FALLBACK_MAX_EDGE = 4096;
  var PRESETS = [[4,4],[6,6],[9,12],[12,12],[12,18],[18,24],[24,24],[36,18],[36,36],[48,24]];

  /* ---------- icons ---------- */
  function iconUpload(s){
    s = s || 38;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 46 46" fill="none" aria-hidden="true">' +
      '<rect x="4" y="6" width="38" height="34" rx="7" stroke="#141414" stroke-width="3" fill="#FFDE1B"/>' +
      '<path d="M23 30V15M23 15l-6.5 6.5M23 15l6.5 6.5" stroke="#141414" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function iconLock(){
    return '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">' +
      '<rect x="4" y="9.5" width="14" height="9.5" rx="2.5" fill="#141414"/>' +
      '<path d="M7 9.5V7a4 4 0 018 0v2.5" stroke="#141414" stroke-width="2.6" fill="none"/></svg>';
  }
  function iconUnlock(){
    return '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">' +
      '<rect x="4" y="9.5" width="14" height="9.5" rx="2.5" fill="#141414"/>' +
      '<path d="M15 9V6.5a4 4 0 00-7.6-1.7" stroke="#141414" stroke-width="2.6" fill="none"/></svg>';
  }
  function iconRotate(){
    return '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<rect x="3.5" y="7" width="10" height="10" rx="1.8" stroke="#141414" stroke-width="2.2"/>' +
      '<path d="M10.5 3.5h3a3 3 0 013 3v1" stroke="#141414" stroke-width="2.2" stroke-linecap="round" fill="none"/>' +
      '<path d="M12.6 1.6l-2.4 1.9 2.4 1.9" stroke="#141414" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
  }

  class PricerApp extends HTMLElement {
    connectedCallback(){
      this.state = {
        stepIdx: 0,
        maxStep: 0,          // furthest step reached — unlocks the progress circles
        w: 12, h: 12,
        /* CIRCULAR: locked by default (Colin, 2026-08-28) — the crop starts
           as a perfect circle and stays one while sizing. Unlocking lets the
           customer break out into an oval, exactly like v2's free reshape.
           (v2 itself starts unlocked; this is the deliberate exception.) */
        locked: true,
        qty: 1,
        artUploaded: false,
        sendLater: false,
        artW: null, artH: null,
        fullSrc: null,
        previewable: false,
        savedCrop: null,     // {x,y,w,h} as fractions of the full image
        cropRatio: null,
        lockRatio: null,     // the w/h the lock holds; see lockedRatio()
        fitMode: null,
        uploadError: null,
        pausedUpload: null,
        detailsOpen: false,
        scaleOpen: false
      };
      this.crop = null;      // {x,y,w,h} in displayed pixels, only while the Size card is mounted
      this.dragMode = null;
      this.dragStart = null;
      /* The largest side this product sells. Custom Mylar sets data-max-size
         to 36 (Colin, 2026-10-14) so it and Large Custom Stencils don't overlap;
         everything else keeps the table's 48. See sizeError. */
      this.maxDim = Math.min(MAX_DIM, parseFloat(this.dataset.maxSize) || MAX_DIM);

      this.bindEls();
      this.form = this.querySelector('form');
      this.bindPersistentEvents();

      /* The review modal is position:fixed and must live directly on <body>.
         Left inside the section, a theme animation utility applying a transform
         to an ancestor silently breaks fixed positioning and renders it
         off-screen while its backdrop still shows — that was the v1 crop-modal
         bug that was never root-caused. */
      if (this.el.cropModal && this.el.cropModal.parentNode !== document.body) {
        document.body.appendChild(this.el.cropModal);
      }

      this.render('fwd');
    }

    disconnectedCallback(){
      if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
      if (this._onWinResize) {
        window.removeEventListener('resize', this._onWinResize);
        window.removeEventListener('orientationchange', this._onWinResize);
      }
      if (this._onPageVisible) {
        document.removeEventListener('visibilitychange', this._onPageVisible);
        window.removeEventListener('pageshow', this._onPageVisible);
      }
      /* A queued jump must not outlive the element — it would fire against a
         detached card host. */
      this._pendingAdvance = null;
      if (this.el && this.el.cropModal && this.el.cropModal.parentNode === document.body) {
        document.body.removeChild(this.el.cropModal);
      }
      closeSizePreview();
    }

    $(ref){ return this.querySelector('[data-ref="' + ref + '"]'); }
    $$(sel){ return Array.prototype.slice.call(this.querySelectorAll(sel)); }

    bindEls(){
      var refs = ['progress','cardhost','stash','qty','fileInput','croppedInput','designerInput',
        'atcBtn','atcNote',
        'noPreviewNote','noPreviewAck','noPreviewSize',
        'propWidth','propHeight','propArtStatus'];
      this.el = {};
      var self = this;
      refs.forEach(function (r) { self.el[r] = self.$(r); });
      // The modal was moved to <body>, so it is no longer a descendant of this
      // element — hold direct references rather than re-querying through $().
      this.el.cropModal = this.querySelector('[data-ref="cropModal"]');
      if (this.el.cropModal) {
        this.el.cropModalImg = this.el.cropModal.querySelector('[data-ref="cropModalImg"]');
        this.el.cropModalBox = this.el.cropModal.querySelector('[data-ref="cropModalBox"]');
      }
    }

    /* Listeners on nodes that live in the stash and get moved between cards.
       Bound once, here — a card re-render moves these nodes, it never recreates
       them, so their listeners survive. */
    bindPersistentEvents(){
      var self = this;

      this.el.fileInput.addEventListener('change', function (e) {
        self.onFileChosen(e.target.files[0]);
        // lets picking the exact same file again still fire 'change'
        if (!e.target.files.length) e.target.value = '';
      });

      if (this.el.noPreviewAck) {
        this.el.noPreviewAck.addEventListener('change', function () {
          self.state.fitMode = this.checked ? 'unverified' : null;
          self.refreshGate();
        });
      }

      // Add to Cart is type="button", not type="submit" — deliberately, so we
      // control the whole sequence: fetch the real price first, swap in the
      // correctly-priced variant, THEN trigger the real form submission (which
      // the theme's own <product-form> handles exactly as it does everywhere
      // else — cart drawer, loading state, etc. — since by that point it's a
      // completely normal submit with the right variant id already in place).
      this.el.atcBtn.addEventListener('click', function () { self.handleAddToCart(); });

      if (this.el.cropModal) {
        this.el.cropModal.addEventListener('click', function () {
          self.el.cropModal.classList.remove('show');
          document.body.classList.remove('pricer-lock');
        });
      }

      /* Pointer drags are tracked on window, not the crop stage: a fast drag
         routinely leaves the element before the pointer is released, and
         losing the move events there would strand the box mid-drag. */
      this._onPointerMove = function (e) { self.onCropPointerMove(e); };
      this._onPointerUp = function () { self.dragMode = null; };
      window.addEventListener('pointermove', this._onPointerMove);
      window.addEventListener('pointerup', this._onPointerUp);
      window.addEventListener('pointercancel', this._onPointerUp);

      /* Re-measure the crop stage when the viewport changes — see reflowCrop.
         rAF-coalesced so a drag-resize doesn't run the maths per pixel. */
      var reflowQueued = false;
      this._onWinResize = function () {
        if (reflowQueued) return;
        reflowQueued = true;
        requestAnimationFrame(function () {
          reflowQueued = false;
          self.reflowCrop();
        });
      };
      window.addEventListener('resize', this._onWinResize);
      window.addEventListener('orientationchange', this._onWinResize);

      this._onKeydown = function (e) {
        if (e.key === 'Escape' && self.el.cropModal && self.el.cropModal.classList.contains('show')) {
          self.el.cropModal.classList.remove('show');
          document.body.classList.remove('pricer-lock');
        }
      };
      document.addEventListener('keydown', this._onKeydown);

      /* Both, deliberately: 'visibilitychange' covers the picker sheet being
         dismissed, and 'pageshow' covers iOS restoring the page from the
         back/forward cache, which does not always fire the first. Running the
         pending advance twice is harmless — runPendingAdvance clears it. */
      this._onPageVisible = function () { self.onPageVisible(); };
      document.addEventListener('visibilitychange', this._onPageVisible);
      window.addEventListener('pageshow', this._onPageVisible);

      /* No swipe-between-steps gesture. The prototype's swipe-right-goes-back
         was removed 2026-10-04 at Colin's request ("on mobile you can kinda
         swipe between the steps which I'd like to disable") — a sideways
         scroll of the preset strip or a sloppy vertical scroll could throw
         the customer back a step. The Back link and the progress circles are
         the only ways between steps now. */
    }

    /* ==================================================================
       NAVIGATION
    ================================================================== */
    stepName(){ return STEPS[this.state.stepIdx]; }
    goNext(){
      var i = Math.min(this.state.stepIdx + 1, STEPS.length - 1);
      if (this.blockedBySize(i)) return;
      this.state.stepIdx = i; this.render('fwd');
    }
    goBack(){ if (this.state.stepIdx > 0) { this.state.stepIdx -= 1; this.render('back'); } }
    jumpTo(i){
      if (this.blockedBySize(i)) return;
      var dir = i < this.state.stepIdx ? 'back' : 'fwd';
      this.state.stepIdx = Math.max(0, Math.min(i, STEPS.length - 1));
      this.render(dir);
    }

    /* UNDER THE MINIMUM IS FLAGGED, NEVER QUIETLY RAISED (Colin, 2026-10-08:
       "If someone types a 1 it can't just turn into a 2 without any sort of
       flag. There needs to be a minimum size note, when they have a 1, and
       they can't proceed to next step"). A typed size below MIN_DIM is kept as
       typed; the Size step shows a note and nothing past it can be reached
       until both sides are at least MIN_DIM. Returns the note's text, or ''.

       OVER THE CAP IS BLOCKED THE SAME WAY (Colin, 2026-10-14: "if any
       dimension is above 36" the customer cannot order custom mylar stencils
       ... If any dimension goes over 36" it should be a large custom
       stencil"). Only where data-max-size lowers the cap below the table's 48,
       i.e. Custom Mylar; everywhere else overCap() is never true. A typed size
       over it is kept as typed, and paintSize adds the Large link to the note. */
    sizeError(){
      var over = this.overCap();
      if (over) {
        var cap = fmtDim(this.maxDim) + '"';
        return 'Custom Mylar Stencils go up to ' + cap + ' × ' + cap + '. ' + (over.w && over.h
          ? 'Your width and height are both over ' + cap + '.'
          : 'Your ' + (over.w ? 'width' : 'height') + ' is ' +
            fmtDim(over.w ? this.state.w : this.state.h) + '", which is over ' + cap + '.');
      }
      var lowW = !(this.state.w >= MIN_DIM), lowH = !(this.state.h >= MIN_DIM);
      if (!lowW && !lowH) return '';
      var min = fmtDim(MIN_DIM) + '"';
      return 'Minimum size is ' + min + ' × ' + min + '. ' + (lowW && lowH
        ? 'Make your width and height at least ' + min + ' to continue.'
        : 'Your ' + (lowW ? 'width' : 'height') + ' is ' +
          fmtDim(Math.max(0, lowW ? this.state.w : this.state.h)) + '" — make it at least ' + min + ' to continue.');
    }
    /* Which sides are over this product's cap, or null. Never true at the
       table's own 48: nothing can hold a side above that except a cap below it. */
    overCap(){
      if (this.maxDim >= MAX_DIM) return null;
      var w = this.state.w > this.maxDim + 0.001, h = this.state.h > this.maxDim + 0.001;
      return (w || h) ? { w: w, h: h } : null;
    }
    /* Where the buttons, slider, chips and crop drag stop: this product's cap.
       Only typing can go past it, and that is flagged rather than rewritten. */
    clampCtl(v){ return Math.min(this.maxDim, Math.max(MIN_DIM, v)); }
    /* The ceiling a typed size is held to. With a lowered cap a typed 40 stays
       40 and is flagged, never quietly turned into 36 (or 48). */
    typedMax(){ return this.maxDim < MAX_DIM ? Infinity : MAX_DIM; }
    /* Every forward route (Next, a progress circle, the post-upload auto
       advance) passes through here. On Size it shows the note and stays put;
       from anywhere else it brings the customer back to Size to fix it. */
    blockedBySize(i){
      var sizeIdx = STEPS.indexOf('Size');
      if (i <= sizeIdx || !this.sizeError()) return false;
      if (this.stepName() === 'Size') this.paintSize();
      else this.jumpTo(sizeIdx);
      return true;
    }

    /* ==================================================================
       RENDER
    ================================================================== */
    render(dir){
      /* Leaving the Size card bakes the crop first, by whatever route the
         customer left it — Continue, Back, or a progress circle. The v1 code
         only baked on an explicit confirm, which is why this is a hook rather
         than a call inside the Continue handler. */
      this.bakeCrop();
      this.returnPersistentNodes();

      this.state.maxStep = Math.max(this.state.maxStep, this.state.stepIdx);
      this.renderProgress();

      var host = this.el.cardhost;
      host.textContent = '';
      var card = document.createElement('div');
      card.className = 'pricer-card' + (dir === 'back' ? ' is-back' : '');

      var name = this.stepName();
      if (name === 'Upload') this.renderUpload(card);
      else if (name === 'Size') this.renderSize(card);
      else if (name === 'Qty') this.renderQty(card);
      else if (name === 'Details') this.renderDetails(card);

      host.appendChild(card);

      /* Crop setup has to happen AFTER the card is in the document: it measures
         the image with clientWidth/clientHeight, which are 0 for a detached
         node, so initialising inside renderSize() silently produced no crop at
         all — no cropped preview, no crop coordinates on the order. rAF gives
         the browser one frame to lay the image out; the load listener in
         renderSize covers the case where the image hasn't decoded yet. */
      if (this.stepName() === 'Size' && this._size && this._size.hasArt) {
        var self = this;
        /* Synchronously first — reading clientWidth on an attached node forces
           layout, so the measurement is available immediately and the crop is
           correct on the very first paint. rAF is a backup for the case where
           the image is attached but not yet laid out; initCrop is idempotent,
           so running twice costs nothing. */
        this.initCrop();
        requestAnimationFrame(function () { self.initCrop(); });
      }

      this.updatePrice();
    }

    /* Puts the moved-around nodes back in the stash before the card host is
       wiped, so wiping can never destroy the file inputs or the Add to Cart
       button along with the card that was borrowing them. */
    returnPersistentNodes(){
      var self = this;
      ['atcBtn', 'atcNote', 'noPreviewNote'].forEach(function (ref) {
        var node = self.el[ref];
        if (node && node.parentNode !== self.el.stash) self.el.stash.appendChild(node);
      });
    }

    renderProgress(){
      var self = this;
      var wrap = this.el.progress;
      wrap.textContent = '';
      STEPS.forEach(function (name, i) {
        var reached = i <= self.state.maxStep;
        var isNow = i === self.state.stepIdx;
        var label = BAR_LABEL[name] || name;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pricer-pstep' + (isNow ? ' is-now' : reached ? ' is-done' : '');
        b.innerHTML = '<span class="dot">' + (reached && !isNow ? '✓' : (i + 1)) + '</span>' +
          '<span class="plbl">' + esc(label) + '</span>';
        if (reached && !isNow) {
          b.setAttribute('aria-label', 'Go to ' + label);
          b.addEventListener('click', function () { self.jumpTo(i); });
        } else {
          b.tabIndex = -1;
          if (isNow) b.setAttribute('aria-current', 'step');
        }
        wrap.appendChild(b);
      });
    }

    /* Card footer: Back on the left, the forward action on the right. The
       Details step passes its own node (the real Add to Cart button) instead of
       getting a generated one. */
    addNav(card, opts){
      opts = opts || {};
      var self = this;
      var nav = document.createElement('div');
      nav.className = 'pricer-cardnav';

      if (opts.backOk !== false) {
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'pricer-backlink';
        back.textContent = '‹ Back';
        back.addEventListener('click', function () { self.goBack(); });
        nav.appendChild(back);
      } else {
        nav.appendChild(document.createElement('span'));
      }

      if (opts.node) {
        nav.appendChild(opts.node);
      } else {
        var nextName = STEPS[this.state.stepIdx + 1];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pricer-btn pricer-btn--primary';
        btn.textContent = nextName ? 'Next: ' + STEP_LABEL[nextName] + ' →' : 'Continue →';
        btn.disabled = !!opts.nextDisabled;
        btn.addEventListener('click', function () { (opts.onNext || function () { self.goNext(); })(); });
        nav.appendChild(btn);
        this._navNext = btn;
      }
      card.appendChild(nav);

      /* The running total sits bottom-right of the card from the Size step
         onward, exactly as in Colin's prototype — the customer should never be
         choosing a size or a quantity without seeing what it costs. Rendered
         per card rather than moved around, because it holds no listeners and no
         state; only the Add to Cart button needs to be a single persistent
         node. */
      if (this.state.stepIdx >= STEPS.indexOf('Size')) {
        var price = document.createElement('div');
        price.className = 'pricer-cardprice';
        price.innerHTML = '<span class="total" data-role="cardtotal">—</span>';
        card.appendChild(price);
      }
      return nav;
    }

    /* ==================================================================
       STEP 1 · UPLOAD
    ================================================================== */
    renderUpload(card){
      var self = this;
      card.innerHTML =
        '<h2 class="pricer-h2">Upload your artwork</h2>' +
        '<p class="pricer-sub">Choose the image you want turned into a stencil.</p>' +
        '<div class="pricer-drop" data-role="drop">' +
          iconUpload(38) +
          '<div class="pricer-drop__big">Drag &amp; drop or choose a file</div>' +
          '<p class="pricer-drop__formats">AI, EPS, SVG, PDF, PSD, PNG, JPG, TIFF</p>' +
          '<button type="button" class="pricer-btn pricer-btn--primary pricer-drop__btn" data-role="choose">Choose file</button>' +
        '</div>' +
        '<p class="pricer-uploaderr" data-role="err"></p>' +
        '<div class="pricer-filelist" data-role="filerow"></div>' +
        '<button type="button" class="pricer-emaillater" data-role="later"></button>' +
        '<div class="pricer-howworks" data-role="how">' +
          '<strong>Here\'s how it works:</strong> after checkout, reply to your order confirmation email with your file, and we\'ll get started on your free proof as soon as it arrives.' +
        '</div>';

      var drop = card.querySelector('[data-role="drop"]');
      card.querySelector('[data-role="choose"]').addEventListener('click', function () { self.el.fileInput.click(); });
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        var f = e.dataTransfer.files[0];
        if (f) self.onFileChosen(f);
      });

      card.querySelector('[data-role="later"]').addEventListener('click', function () { self.toggleSendLater(); });

      // The no-preview acknowledgement belongs with the file that triggered it.
      card.appendChild(this.el.noPreviewNote);

      this.addNav(card, { backOk: false, nextDisabled: !this.canLeaveUpload() });
      this.paintUpload();
    }

    canLeaveUpload(){
      if (this.state.sendLater) return true;
      if (!this.state.artUploaded) return false;
      // A file we can't rasterise skips the proportion check every other file
      // has to pass, so it needs the explicit acknowledgement first.
      if (!this.state.previewable && this.el.noPreviewAck && !this.el.noPreviewAck.checked) return false;
      return true;
    }

    /* Called only from the two places an upload can become croppable: the image
       path's img.onload and renderPdfPreview's success. Colin asked for this so
       a customer who has just given us something croppable doesn't have to press
       Continue to reach the crop. Deliberately narrow — each guard below is a
       way this could move somebody who did not ask to be moved:

         seq          the upload it was queued for is still the current one.
                      Choosing a second file before the first decodes leaves the
                      first load in flight; without this it would arrive late and
                      advance the customer on behalf of a file they replaced.
         Upload step  a re-upload started from Review's "edit artwork" link ends
                      up here too. Advancing from anywhere but Upload would throw
                      away the place they were at.
         croppable    the same test renderSize uses for hasArt. A file we cannot
                      rasterise has no crop to show and still owes its
                      acknowledgement tick, so it stays put.
         canLeave     never step over the gate. If it says no, so does this.
         maxStep      only ever forward. Someone who walked back to Upload from
                      Qty to swap the file returns to Qty, not to Size.

       No "already advanced" flag is needed: nothing re-fires a decode, so one
       chosen file can produce at most one of these. */
    maybeAutoAdvance(seq){
      var self = this;
      if (!this.advanceStillWanted(seq)) return;

      /* Parked on the instance rather than captured only by the timer, because
         the timer is not the only thing that can run it — see onPageVisible. */
      this._pendingAdvance = {
        seq: seq,
        target: Math.max(STEPS.indexOf('Size'), this.state.maxStep),
        dueAt: Date.now() + AUTO_ADVANCE_MS
      };
      window.setTimeout(function () { self.runPendingAdvance(seq); }, AUTO_ADVANCE_MS);
    }

    /* Every guard in one place. It used to be written out twice — once on the
       way into the timer and once on the way out — and now that a second route
       can fire the advance, three copies would be three chances to drift. */
    advanceStillWanted(seq){
      if (seq !== this._uploadSeq) return false;
      if (this.stepName() !== 'Upload') return false;
      if (this.state.sendLater) return false;
      if (!this.state.artUploaded || !this.state.previewable || !this.state.fullSrc) return false;
      return this.canLeaveUpload();
    }

    /* Re-checked at the moment of the jump, never only when it was queued: the
       customer has had AUTO_ADVANCE_MS to remove the file, hit "email it after
       ordering", choose a different file, or walk off the step themselves, and
       any of those makes the jump wrong. */
    runPendingAdvance(seq){
      var p = this._pendingAdvance;
      if (!p || p.seq !== seq) return;
      if (!this.advanceStillWanted(seq)) { this._pendingAdvance = null; return; }
      this._pendingAdvance = null;
      this.jumpTo(p.target);
      this.scrollCardIntoView();
    }

    /* THE PHONE BUG (Colin, 2026-09-09: "on my phone it's not automatically
       going to the second step after upload").

       On a desktop the file picker is a separate window and the page behind it
       stays visible, so the AUTO_ADVANCE_MS timer runs normally — which is why
       this was verified working on live and stayed broken on a phone. On iOS
       the picker is a sheet presented OVER the page: the page goes hidden, and
       a hidden page's timers are clamped to >=1s and can be dropped outright
       while the sheet is dismissed. The decode finishes (the thumbnail is
       there, which is why the upload looks fine) but the jump that was queued
       behind it never arrives.

       So the timer is no longer the only thing that can complete the advance.
       Coming back to a visible page re-runs it — immediately if the beat has
       already elapsed while we were away, otherwise re-armed for the remainder
       so the thumbnail still gets its moment. */
    onPageVisible(){
      var self = this;
      if (document.visibilityState === 'hidden') return;
      var p = this._pendingAdvance;
      if (!p) return;
      var left = p.dueAt - Date.now();
      if (left <= 0) this.runPendingAdvance(p.seq);
      else window.setTimeout(function () { self.runPendingAdvance(p.seq); }, left);
    }

    /* The card is swapped in place, so on a tall phone page a customer who was
       looking at the upload button can be left mid-card with the step counter
       and the heading scrolled off above them — the jump happened, but nothing
       on screen says so. Only ever pulls the card UP into view, and only when
       its top is actually out of sight; a card already in view is left alone
       so this can't yank the page around on a desktop. */
    scrollCardIntoView(){
      var card = this.el.cardhost && this.el.cardhost.firstChild;
      if (!card || !card.getBoundingClientRect) return;
      var top = card.getBoundingClientRect().top;
      if (top >= 0 && top < (window.innerHeight || 0) * 0.5) return;
      try { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      catch (e) { card.scrollIntoView(); }
    }

    paintUpload(){
      var self = this;
      var card = this.el.cardhost.firstChild;
      if (!card || this.stepName() !== 'Upload') return;

      var later = card.querySelector('[data-role="later"]');
      later.classList.toggle('is-on', this.state.sendLater);
      later.innerHTML = this.state.sendLater
        ? '✓ You’ll email artwork after ordering — <u>undo</u>'
        : 'Still working on your file? Email it after ordering';
      card.querySelector('[data-role="how"]').classList.toggle('show', this.state.sendLater);
      card.querySelector('[data-role="err"]').textContent = this.state.uploadError || '';

      var row = card.querySelector('[data-role="filerow"]');
      row.textContent = '';
      if (this.state.artUploaded) {
        var item = document.createElement('div');
        item.className = 'pricer-fileitem';
        var img = document.createElement('img');
        img.alt = '';
        img.src = this.state.fullSrc || FILE_ICON;
        var nameEl = document.createElement('span');
        nameEl.className = 'fname';
        nameEl.textContent = this._fileName || 'Your artwork';
        /* Only while there is something to say. A finished, previewable upload
           says nothing — the thumbnail beside the filename already is the
           confirmation, and the prototype's chip is just thumbnail + name + ✕.
           The slow paths (reading, converting a PDF) and the hand-check note
           still speak, because those the customer can't see for themselves. */
        var status = document.createElement('span');
        status.className = 'fstatus';
        status.textContent = this._fileStatus || '';
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'fremove';
        remove.setAttribute('aria-label', 'Remove file');
        remove.textContent = '✕';
        remove.addEventListener('click', function () { self.clearArtwork(); self.paintUpload(); self.refreshGate(); });
        var meta = document.createElement('span');
        meta.className = 'fmeta';
        meta.appendChild(nameEl);
        if (status.textContent) meta.appendChild(status);
        item.appendChild(img);
        item.appendChild(meta);
        item.appendChild(remove);
        row.appendChild(item);
      }

      var needsAck = this.state.artUploaded && !this.state.previewable;
      this.el.noPreviewNote.classList.toggle('show', needsAck);
      if (needsAck && this.el.noPreviewSize) {
        this.el.noPreviewSize.textContent = fmtDim(this.state.w) + ' × ' + fmtDim(this.state.h) + '″';
      }

      if (this._navNext) this._navNext.disabled = !this.canLeaveUpload();
    }

    clearArtwork(){
      this.state.artUploaded = false;
      this.state.artW = null; this.state.artH = null;
      this.state.fullSrc = null; this.state.previewable = false;
      this.state.savedCrop = null; this.state.cropRatio = null;
      this.state.fitMode = null; this.state.uploadError = null;
      this.state.lockRatio = null;   // recaptured from the sizes on next use
      this._fileName = null; this._fileStatus = null;
      this.crop = null;
      this.el.fileInput.value = '';
      if (this.el.croppedInput) this.el.croppedInput.value = '';
      if (this.el.designerInput) this.el.designerInput.value = '';
      if (this.el.noPreviewAck) this.el.noPreviewAck.checked = false;
    }

    /* ==================================================================
       STEP 2 · SIZE (dimensions + crop together)
    ================================================================== */
    renderSize(card){
      var self = this;
      var hasArt = this.state.artUploaded && this.state.previewable && !!this.state.fullSrc;

      var cap = this.maxDim;
      var presetHtml = PRESETS.map(function (p) {
        // A chip past the cap (48×24 on Mylar) would only land on the over-size note.
        if (p[0] > cap || p[1] > cap) return '';
        return '<button type="button" class="pricer-preset" data-w="' + p[0] + '" data-h="' + p[1] + '">' +
          p[0] + '×' + p[1] + '"</button>';
      }).join('');

      card.innerHTML =
        '<h2 class="pricer-h2">Size it</h2>' +
        '<p class="pricer-sub">We add a 1" border on each side around your design.</p>' +
        '<div class="pricer-sizerow">' +
          '<div class="pricer-field">' +
            '<label for="pricer-w-' + this.dataset.uid + '">Width (in)</label>' +
            '<div class="pricer-nudge">' +
              '<button type="button" class="minibtn" data-role="wMinus" aria-label="Decrease width">−</button>' +
              '<input id="pricer-w-' + this.dataset.uid + '" data-role="inW" class="nospin" type="number" min="' + MIN_DIM + '" max="' + cap + '" step="any" inputmode="decimal">' +
              '<button type="button" class="minibtn" data-role="wPlus" aria-label="Increase width">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="pricer-lockbtn" data-role="lock" aria-pressed="' + this.state.locked + '"></button>' +
          '<div class="pricer-field">' +
            '<label for="pricer-h-' + this.dataset.uid + '">Height (in)</label>' +
            '<div class="pricer-nudge">' +
              '<button type="button" class="minibtn" data-role="hMinus" aria-label="Decrease height">−</button>' +
              '<input id="pricer-h-' + this.dataset.uid + '" data-role="inH" class="nospin" type="number" min="' + MIN_DIM + '" max="' + cap + '" step="any" inputmode="decimal">' +
              '<button type="button" class="minibtn" data-role="hPlus" aria-label="Increase height">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="pricer-sliderwrap">' +
          '<input type="range" data-role="slider" min="' + MIN_DIM + '" max="' + cap + '" step="0.5" aria-label="Scale size">' +
          '<div class="ends"><span>' + MIN_DIM + '"</span><span>Drag to scale</span><span>' + cap + '"</span></div>' +
        '</div>' +
        '<p class="pricer-oversize" data-role="oversize">Looking for something bigger? Our <a href="' + LARGE_URL + '">Large Custom Stencils</a> go past ' + cap + '".</p>' +
        '<p class="pricer-oversize pricer-minsize" data-role="minsize" role="alert"></p>' +
        '<div class="pricer-presets" data-role="presets">' + presetHtml + '</div>' +
        (hasArt
          ? '<div class="pricer-cropwrap" data-role="cropwrap">' +
              '<img data-role="cropimg" src="' + esc(this.state.fullSrc) + '" alt="Your uploaded design">' +
              '<div class="pricer-cropbox" data-role="cropbox">' +
                '<div class="handle h-nw" data-h="nw"></div><div class="handle h-ne" data-h="ne"></div>' +
                '<div class="handle h-sw" data-h="sw"></div><div class="handle h-se" data-h="se"></div>' +
              '</div>' +
              '<button type="button" class="pricer-croprotate" data-role="rotate" title="Rotate — swap width and height" aria-label="Rotate: swap width and height">' + iconRotate() + '</button>' +
            '</div>' +
            /* No hint line under the crop — removed 2026-08-21 (Colin). The
               lock button's own tooltip carries the explanation. */
            '<button type="button" class="pricer-scaletoggle" data-role="scaletoggle"></button>' +
            '<div class="pricer-scalewrap" data-role="scalewrap"><div class="pricer-scalebox"><div data-role="scalefig"></div></div></div>'
          : '<div class="pricer-scalebox"><div data-role="scalefig"></div></div>' +
            (this.state.sendLater
              ? '<p class="pricer-upnote">Your size for reference — we\'ll fit your emailed artwork to it.</p>'
              : '<p class="pricer-upnote">Your size for reference — a designer will check your file against it.</p>'));

      var inW = card.querySelector('[data-role="inW"]');
      var inH = card.querySelector('[data-role="inH"]');
      var slider = card.querySelector('[data-role="slider"]');
      var lockBtn = card.querySelector('[data-role="lock"]');

      this._size = {
        card: card, inW: inW, inH: inH, slider: slider, lockBtn: lockBtn,
        img: card.querySelector('[data-role="cropimg"]'),
        box: card.querySelector('[data-role="cropbox"]'),
        hasArt: hasArt
      };

      /* ---- dimension controls ---- */
      /* Locked, each side drags the other along at the shape that was locked
         (lockedRatio), not one re-read from the rounded sides — see there. */
      var applyW = function (v) {
        if (!Number.isFinite(v)) return;
        if (self.state.locked) self.setPair(self.clampCtl(v), self.lockedRatio());
        else self.state.w = self.clampCtl(v);
        self.paintSize();
      };
      var applyH = function (v) {
        if (!Number.isFinite(v)) return;
        if (self.state.locked) {
          var r = self.lockedRatio();
          self.setPair(self.clampCtl(v) * r, r);
        } else self.state.h = self.clampCtl(v);
        self.paintSize();
      };

      /* input tracks keystrokes live for the price WITHOUT clamping-and-
         rewriting the field on every character — rewriting mid-typing was
         actively hostile to typing itself ("14" begins as "1", which alone is
         below MIN_DIM and used to get rewritten as "2"). Range clamping happens
         once they're done editing, on focusout. Flagged by Colin, 2026-08-11.
         That fix only held while unlocked: locked, setPair clamped the "1" up
         to 2 and paintSize wrote it straight back into the field being typed
         in ("Pricer glitch again", 2026-10-07). paintSize's `typing` flag now
         leaves that field alone, as pricer-lg.js already did. */
      inW.addEventListener('input', function () {
        var v = parseFloat(inW.value);
        if (!Number.isFinite(v)) return;
        self.state.oversize = v > MAX_DIM;
        /* noFloor: under the minimum is kept as typed and flagged (see
           sizeError); so is over a lowered cap (typedMax). */
        if (self.state.locked) self.setPair(Math.min(v, self.typedMax()), self.lockedRatio(), true);
        else self.state.w = Math.min(v, self.typedMax());
        self.paintSize(true, true);
      });
      inH.addEventListener('input', function () {
        var v = parseFloat(inH.value);
        if (!Number.isFinite(v)) return;
        self.state.oversize = v > MAX_DIM;
        if (self.state.locked) {
          var r = self.lockedRatio();
          self.setPair(Math.min(v, self.typedMax()) * r, r, true);
        } else self.state.h = Math.min(v, self.typedMax());
        self.paintSize(true, true);
      });
      /* focusout finalizes the pair once the customer is done with BOTH fields,
         not the instant either one loses focus — width and height are one
         logical entry, and tabbing between them is mid-entry, not "done".
         activeElement on a deferred tick rather than e.relatedTarget, which is
         only reliably populated for keyboard-driven focus moves (Colin
         reproduced the premature clamp by tapping between fields in mobile
         emulation, where relatedTarget was unset). */
      [inW, inH].forEach(function (input) {
        input.addEventListener('focusout', function () {
          setTimeout(function () {
            var active = document.activeElement;
            if (active === inW || active === inH) return;
            /* Ceiling only. A size under the minimum is no longer floored here —
               it stays as typed and paintSize flags it (see sizeError). */
            self.state.w = Math.min(self.state.w, self.typedMax());
            self.state.h = Math.min(self.state.h, self.typedMax());
            self.state.oversize = false;
            self.paintSize();
          }, 0);
        });
      });

      card.querySelector('[data-role="wMinus"]').addEventListener('click', function () { applyW(self.state.w - 0.5); });
      card.querySelector('[data-role="wPlus"]').addEventListener('click', function () { applyW(self.state.w + 0.5); });
      card.querySelector('[data-role="hMinus"]').addEventListener('click', function () { applyH(self.state.h - 0.5); });
      card.querySelector('[data-role="hPlus"]').addEventListener('click', function () { applyH(self.state.h + 0.5); });

      /* The ratio is anchored at gesture start so quarter-inch rounding on each
         tick can't slowly drift the shape over a long drag — and while locked,
         to the locked shape, so repeated drags can't drift it either. */
      var sliderRatio = null;
      var currentRatio = function () {
        return self.state.locked ? self.lockedRatio() : self.state.w / self.state.h;
      };
      ['mousedown', 'touchstart', 'keydown'].forEach(function (ev) {
        slider.addEventListener(ev, function () { sliderRatio = currentRatio(); }, { passive: true });
      });
      slider.addEventListener('change', function () { sliderRatio = null; });
      slider.addEventListener('input', function () {
        var target = parseFloat(slider.value);
        var r = sliderRatio || currentRatio();
        if (r >= 1) self.setPair(target, r);
        else self.setPair(target * r, r);
        self.paintSize();
      });

      lockBtn.addEventListener('click', function () {
        self.state.locked = !self.state.locked;
        self.relockRatio();
        // Re-locking snaps the crop back to the current numbers.
        if (self.state.locked) self.fitCropToRatio();
        self.paintSize();
      });

      var presets = card.querySelector('[data-role="presets"]');
      var dragged = this.enableDragScroll(presets);
      presets.querySelectorAll('.pricer-preset').forEach(function (b) {
        b.addEventListener('click', function () {
          if (dragged()) return;   // that was a scroll gesture, not a tap
          self.state.w = parseFloat(b.dataset.w);
          self.state.h = parseFloat(b.dataset.h);
          self.relockRatio();   // a chip is an explicit shape; the lock keeps that one now
          self.paintSize();
        });
      });

      /* ---- crop ---- */
      if (hasArt) {
        var box = this._size.box;
        var img = this._size.img;
        box.addEventListener('pointerdown', function (e) { self.onCropPointerDown(e); });

        var rotate = card.querySelector('[data-role="rotate"]');
        // Keep the rotate tap from starting a crop drag underneath it.
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
          rotate.addEventListener(ev, function (e) { e.stopPropagation(); });
        });
        rotate.addEventListener('click', function (e) {
          e.stopPropagation();
          self.rotateSize();
        });

        var scaleToggle = card.querySelector('[data-role="scaletoggle"]');
        scaleToggle.addEventListener('click', function () {
          self.state.scaleOpen = !self.state.scaleOpen;
          self.paintSize();
        });

        if (img.complete && img.naturalWidth) this.initCrop();
        else img.addEventListener('load', function () { self.initCrop(); });
      }

      this.addNav(card, { backOk: true });
      this.paintSize();
    }

    /* Sets both dimensions at ratio r, clamped jointly so neither side leaves
       [MIN_DIM, MAX_DIM] — clamping them independently is what used to let the
       slider bottom out at 2×2 on a wide image. noFloor (typing only) keeps
       the ceiling but not the floor, so an under-minimum entry is flagged by
       sizeError instead of silently raised. The ceiling is the product's cap
       (36" on Mylar), or for typing typedMax, so a typed 40 isn't rewritten. */
    setPair(w, r, noFloor){
      if (!Number.isFinite(w) || !Number.isFinite(r) || r <= 0) return;
      var top = noFloor ? this.typedMax() : this.maxDim;
      w = Math.min(w, top, top * r);
      if (!noFloor) w = Math.max(w, MIN_DIM, MIN_DIM * r);
      this.state.w = snap4(w);
      this.state.h = snap4(w / r);
    }

    /* The shape the lock is holding (Colin, "Pricer glitch", 2026-10-07: "Box
       is not supposed to change obviously when the proportion is the same").
       It used to be re-read from the rounded sides on every +/− tap, and each
       tap snapped both sides to the quarter inch again, so the shape crept:
       9.75 × 15 (0.650) walked to 11.5 × 18.5 (0.622) in a few taps, and the
       crop frame grew taller with it. Captured once when the lock goes on, or
       when a chip or rotate sets an explicit new shape, and captured lazily for
       any path that turns the lock on without passing through those.
       (Kept directly under setPair: build-coffee-pricer.js replaces the code
       on either side, and coffee's crop still calls these.) */
    lockedRatio(){
      if (!this.state.lockRatio) this.state.lockRatio = clampDim(this.state.w) / clampDim(this.state.h);
      return this.state.lockRatio;
    }
    relockRatio(){
      this.state.lockRatio = this.state.locked ? clampDim(this.state.w) / clampDim(this.state.h) : null;
    }

    rotateSize(){
      var t = this.state.w; this.state.w = this.state.h; this.state.h = t;
      this.relockRatio();
      if (this.crop && this._size && this._size.img) {
        /* Rotate the crop frame about its own centre: the pixel dimensions swap,
           scaled down only if the rotated frame would poke outside the image. */
        var W = this._size.img.clientWidth, H = this._size.img.clientHeight;
        if (W && H) {
          var cx = this.crop.x + this.crop.w / 2, cy = this.crop.y + this.crop.h / 2;
          var nw = this.crop.h, nh = this.crop.w;
          var s = Math.min(1, W / nw, H / nh);
          nw *= s; nh *= s;
          this.crop.w = nw; this.crop.h = nh;
          this.crop.x = cx - nw / 2; this.crop.y = cy - nh / 2;
          this.clampCrop();
          /* clampCrop only updates the numbers — paintCrop is what writes them
             to the box's style. Without it rotate swapped the width/height
             fields while the crop frame sat there unmoved (Colin, 2026-08-20).
             paintSize(true) can't cover for it: fromCrop deliberately skips
             fitCropToRatio, which is the only other route to a repaint. */
          this.paintCrop();
        }
      }
      this.paintSize(true);   // crop already handled — don't refit it underneath
    }

    /* fromCrop: the crop drove this change, so don't refit the crop from the
       numbers and undo what the customer just dragged.
       typing: a keystroke drove it. Only the OTHER field is rewritten, and only
       when locked; rewriting the one under the cursor fights the keystrokes. */
    paintSize(fromCrop, typing){
      if (!this._size || this.stepName() !== 'Size') return;
      var s = this._size;
      if (!typing) {
        s.inW.value = fmtDim(this.state.w);
        s.inH.value = fmtDim(this.state.h);
      } else if (this.state.locked) {
        var mirror = (document.activeElement === s.inW) ? s.inH : s.inW;
        mirror.value = fmtDim(mirror === s.inW ? this.state.w : this.state.h);
      }
      s.slider.value = fmtDim(Math.max(this.state.w, this.state.h));

      s.lockBtn.innerHTML = this.state.locked ? iconLock() : iconUnlock();
      s.lockBtn.setAttribute('aria-pressed', String(this.state.locked));
      // Rebuilt every paint rather than set once at render — a title baked in at
      // render time still described the opposite state after the first toggle.
      s.lockBtn.title = this.state.locked
        ? 'Proportions locked — the crop keeps this shape. Unlock to reshape it.'
        : 'Proportions unlocked — drag the crop to reshape, and the size follows.';


      /* The "bigger?" pointer to Large shows whenever either side is AT the
         48" ceiling, not only while typing past it. `state.oversize` is true
         only mid-keystroke and is cleared on focusout, so a customer who picked
         48 × 48, dragged the slider to max, or typed 60 and tabbed away never
         saw it (Colin, 2026-10-04). Same fix Large got on 2026-09-05. The
         tolerance absorbs float drift from the locked-ratio setPair. */
      /* Over a lowered cap the red note below says it, with the link, so the
         amber one stands down rather than say it twice. */
      var overCap = this.overCap();
      var cap = this.maxDim;
      var over = s.card.querySelector('[data-role="oversize"]');
      var atCeiling = !overCap && (this.state.oversize ||
        this.state.w >= cap - 0.01 || this.state.h >= cap - 0.01);
      if (over) over.classList.toggle('show', !!atCeiling);

      /* Under the minimum (see sizeError). Next is held off the moment the
         size goes under, but the note itself waits until the customer has
         finished the entry, so "14" doesn't flash a warning at its first "1".
         It clears the instant the size is valid again, mid-typing or not.
         Over the cap shows at once: more digits can't bring "40" back down. */
      var err = this.sizeError();
      var minNote = s.card.querySelector('[data-role="minsize"]');
      if (minNote) {
        if (!err) { minNote.classList.remove('show'); minNote.innerHTML = ''; }
        else if (!typing || overCap || minNote.classList.contains('show')) {
          /* innerHTML for the Large link. err is escaped and the rest is a
             fixed literal, so no customer input reaches the markup. */
          minNote.innerHTML = esc(err) + (overCap
            ? ' Please order <a href="' + LARGE_URL + '">Large Custom Stencils</a> instead.'
            : '');
          minNote.classList.add('show');
        }
        var flagged = minNote.classList.contains('show');
        [[s.inW, this.state.w], [s.inH, this.state.h]].forEach(function (p) {
          var bad = flagged && (!(p[1] >= MIN_DIM) || p[1] > cap + 0.001);
          p[0].closest('.pricer-nudge').classList.toggle('is-invalid', bad);
          p[0].setAttribute('aria-invalid', String(bad));
        });
      }
      if (this._navNext) this._navNext.disabled = !!err;

      s.card.querySelectorAll('.pricer-preset').forEach(function (b) {
        var on = Math.abs(this.state.w - parseFloat(b.dataset.w)) < 0.01 &&
                 Math.abs(this.state.h - parseFloat(b.dataset.h)) < 0.01;
        b.classList.toggle('is-on', on);
      }, this);

      var rotate = s.card.querySelector('[data-role="rotate"]');
      if (rotate) rotate.classList.toggle('is-hidden', Math.abs(this.state.w / this.state.h - 1) < 0.02);

      var toggle = s.card.querySelector('[data-role="scaletoggle"]');
      var wrap = s.card.querySelector('[data-role="scalewrap"]');
      if (toggle && wrap) {
        toggle.textContent = this.state.scaleOpen ? 'Hide scale preview' : 'See it for scale';
        wrap.classList.toggle('show', this.state.scaleOpen);
      }
      if (!s.hasArt || this.state.scaleOpen) this.drawScale(s.card.querySelector('[data-role="scalefig"]'));

      if (!fromCrop && s.hasArt) this.fitCropToRatio();
      this.updatePrice();
    }

    /* Give the crop stage a FLOOR, not just a ceiling (Colin, 2026-08-24).
       The CSS sizes the image with `width:auto; max-width:100%`, so it drew at
       its natural pixel size — a 60×60px upload rendered as a 60×60 box with a
       crop frame too small to grab. Capped at the top, never floored at the
       bottom. Now the image always fills the card's content width, so small and
       large files present identically.

       Why an explicit pixel width and not a CSS `width:100%`: `.pricer-cropbox`
       is absolutely positioned inside `.pricer-cropwrap`, and the wrapper is
       `width:fit-content` specifically so its box coincides with the image's —
       that coincidence is what keeps the crop frame registered over the
       artwork. Setting the IMAGE's width keeps the wrapper shrink-wrapped to
       it; widening the WRAPPER instead would offset every crop coordinate.

       Height is capped before width is applied rather than left to the CSS
       `max-height`: with an explicit width, `max-height` would clamp the height
       without recomputing the width, squashing the aspect ratio. The cap is
       read off the computed style so the value stays in one place (the CSS)
       instead of being duplicated here. */
    sizeCropImage(){
      var s = this._size;
      if (!s || !s.img) return;
      var img = s.img;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return;

      var wrap = img.parentNode;
      var host = wrap && wrap.parentNode;
      if (!host) return;
      var hcs = getComputedStyle(host);
      // clientWidth is content + padding, so the padding comes back off.
      var avail = host.clientWidth
        - (parseFloat(hcs.paddingLeft) || 0)
        - (parseFloat(hcs.paddingRight) || 0);
      if (!(avail > 0)) return;

      var ics = getComputedStyle(img);
      /* The image's own border, cached here because paintCrop needs it on every
         frame of a drag. See paintCrop for what it is for. */
      s.bl = parseFloat(ics.borderLeftWidth) || 0;
      s.bt = parseFloat(ics.borderTopWidth) || 0;

      var maxH = parseFloat(ics.maxHeight);
      if (!Number.isFinite(maxH) || maxH <= 0) maxH = 420;

      /* A tall photo hits the height cap first and stays narrower than the
         card — deliberate, and unchanged from before: letting a 9:16 phone
         photo span the full width would run it off the bottom of the page. */
      var w = avail;
      if (w * (nh / nw) > maxH) w = maxH * (nw / nh);

      img.style.width = w + 'px';
      img.style.height = (w * nh / nw) + 'px';

      /* A small raster scaled up gets bilinear-smoothed into a blur (Colin,
         2026-08-24, on seeing the fix above). Nothing can restore detail the
         file never had — but stencil artwork is hard-edged black shapes, and
         for that `pixelated` reads as sharp blocks rather than a fuzzy smear.
         Only past 2×: below that the browser's smoothing is the better result,
         and it keeps genuine photos (which pixelate badly) on the default path.
         Display only — the cropped preview and the Designer SVG both render
         from the natural-resolution image, so neither is affected. */
      img.classList.toggle('is-upscaled', w / nw >= 2);
    }

    /* A viewport resize or phone rotation re-lays the card out, which leaves
       BOTH the explicit width above and the crop's displayed-pixel coordinates
       stale — the frame drifts off the artwork. Reproject through fractions,
       which are resolution-independent, then re-measure. */
    reflowCrop(){
      var s = this._size;
      if (!s || !s.img || !s.hasArt) return;
      var img = s.img;
      var W = img.clientWidth, H = img.clientHeight;
      var frac = (this.crop && W && H)
        ? { x: this.crop.x / W, y: this.crop.y / H, w: this.crop.w / W, h: this.crop.h / H }
        : null;

      this.sizeCropImage();

      var nW = img.clientWidth, nH = img.clientHeight;
      if (!nW || !nH) return;
      if (!frac) { this.initCrop(); return; }
      this.crop = { x: frac.x * nW, y: frac.y * nH, w: frac.w * nW, h: frac.h * nH };
      this.clampCrop();
      this.paintCrop();
    }

    initCrop(){
      var s = this._size;
      if (!s || !s.img) return;
      /* Before measuring, not after: every calculation below is in displayed
         pixels, so the image has to be at its final size first. */
      this.sizeCropImage();
      var W = s.img.clientWidth, H = s.img.clientHeight;
      if (!W || !H) return;
      /* Idempotent: this can be called from rAF, from the image's load event,
         and again if the image re-lays out. Once there's a crop, later calls
         only re-clamp it — they must never reseed and wipe out a drag. */
      if (this.crop) { this.clampCrop(); this.paintCrop(); return; }
      if (this.state.savedCrop) {
        var c = this.state.savedCrop;
        this.crop = { x: c.x * W, y: c.y * H, w: c.w * W, h: c.h * H };
      } else {
        var r = this.state.w / this.state.h;
        var cw = W * 0.8, ch = cw / r;
        if (ch > H * 0.9) { ch = H * 0.9; cw = ch * r; }
        this.crop = { x: (W - cw) / 2, y: (H - ch) / 2, w: cw, h: ch };
      }
      this.clampCrop();
      this.paintCrop();
    }

    fitCropToRatio(){
      var s = this._size;
      if (!s || !s.img || !this.crop) return;
      var W = s.img.clientWidth, H = s.img.clientHeight;
      /* BUG FIX (v2 prototype): without this guard, a tap on +/−, the slider or
         a preset before the image has finished decoding runs the maths against
         a zero-sized element, collapses the crop to 0×0, and it never recovers
         because initCrop only seeds a crop when there isn't one. */
      if (!W || !H) return;
      /* Locked, the frame takes the LOCKED shape, not the rounded sides'. The
         sides land on the nearest quarter inch, so their ratio wobbles a hair
         with every +/− tap; fitting to that made the frame twitch while the
         proportion was meant to be fixed. */
      /* Unlocked, clamped: an under-minimum entry is now kept as typed, and a
         typed 0 would otherwise make r 0 and collapse the frame to nothing. */
      var r = this.state.locked ? this.lockedRatio() : clampDim(this.state.w) / clampDim(this.state.h);
      var cw = this.crop.w, ch = cw / r;
      /* Clamp to the stage, never back off to 90% of it: backing off made a
         frame that exactly filled the artwork lose a tenth of itself on every
         size nudge, walking it back off the edges (same fix as pricer-lg.js). */
      if (ch > H) { ch = H; cw = ch * r; }
      if (cw > W) { cw = W; ch = cw / r; }
      this.crop.w = cw; this.crop.h = ch;
      this.clampCrop();
      this.paintCrop();
    }

    clampCrop(){
      var s = this._size;
      if (!s || !s.img || !this.crop) return;
      var W = s.img.clientWidth, H = s.img.clientHeight;
      if (!W || !H) return;
      this.crop.w = Math.min(this.crop.w, W);
      this.crop.h = Math.min(this.crop.h, H);
      this.crop.x = Math.min(Math.max(0, this.crop.x), W - this.crop.w);
      this.crop.y = Math.min(Math.max(0, this.crop.y), H - this.crop.h);
    }

    /* Crop coordinates live in the image's CONTENT box (clientWidth/Height,
       which exclude its 2px border), but .pricer-cropbox is positioned inside
       .pricer-cropwrap, whose content box is the image's BORDER box. Unadjusted,
       a frame covering the whole artwork stopped 4px short of the right and
       bottom edges (Colin, "Crop box", 2026-09-24). Same fix as pricer-lg.js. */
    paintCrop(){
      var s = this._size;
      if (!s || !s.box || !this.crop) return;
      s.box.style.left = (this.crop.x + (s.bl || 0)) + 'px';
      s.box.style.top = (this.crop.y + (s.bt || 0)) + 'px';
      s.box.style.width = this.crop.w + 'px';
      s.box.style.height = this.crop.h + 'px';
    }

    onCropPointerDown(e){
      var s = this._size;
      /* BUG FIX (v2 prototype): grabbing the box before the image has decoded
         left crop null, and the scale factor below came out NaN — every
         subsequent drag then wrote NaN into the width and height. */
      if (!s || !s.img || !this.crop) return;
      if (e.target.dataset.h) this.dragMode = e.target.dataset.h;
      else if (e.target === s.box) this.dragMode = 'move';
      else return;

      this.dragStart = {
        px: e.clientX, py: e.clientY,
        x: this.crop.x, y: this.crop.y, w: this.crop.w, h: this.crop.h,
        /* Inches per pixel, captured per axis. The prototype derived height
           from the WIDTH scale factor, so once the crop's shape and the size's
           shape diverged, a purely horizontal drag silently changed the height
           too. */
        kx: this.state.w / this.crop.w,
        ky: this.state.h / this.crop.h
      };
      e.preventDefault();
    }

    onCropPointerMove(e){
      if (!this.dragMode) return;
      var s = this._size;
      if (!s || !s.img || !this.crop) { this.dragMode = null; return; }
      var W = s.img.clientWidth, H = s.img.clientHeight;
      if (!W || !H) return;

      var st = this.dragStart;
      var dx = e.clientX - st.px, dy = e.clientY - st.py;

      if (this.dragMode === 'move') {
        this.crop.x = st.x + dx;
        this.crop.y = st.y + dy;
        this.clampCrop();
        this.paintCrop();
      } else {
        var mode = this.dragMode;
        /* Space available from the anchored (opposite) corner, so a resize can
           never push past the image edge — which is what stops the boundary
           clamp from squashing the locked ratio. */
        var maxW = (mode.indexOf('w') !== -1) ? st.x + st.w : W - st.x;
        var maxH = (mode.indexOf('n') !== -1) ? st.y + st.h : H - st.y;
        var ratio = this.state.locked ? this.lockedRatio() : null;
        var nw, nh;

        if (mode === 'se' || mode === 'ne') nw = Math.max(40, st.w + dx);
        else nw = Math.max(40, st.w - dx);

        if (ratio) {
          nw = Math.min(nw, maxW, maxH * ratio);
          nh = nw / ratio;
        } else {
          if (mode === 'se' || mode === 'sw') nh = Math.max(40, st.h + dy);
          else nh = Math.max(40, st.h - dy);
          nw = Math.min(nw, maxW);
          nh = Math.min(nh, maxH);
        }

        this.crop.w = nw; this.crop.h = nh;
        this.crop.x = (mode === 'nw' || mode === 'sw') ? st.x + st.w - nw : st.x;
        this.crop.y = (mode === 'nw' || mode === 'ne') ? st.y + st.h - nh : st.y;
        this.clampCrop();
        this.paintCrop();

        if (!this.state.locked) {
          // Unlocked: the crop drives the size, each axis by its own scale.
          this.state.w = snap4(this.clampCtl(this.crop.w * st.kx));
          this.state.h = snap4(this.clampCtl(this.crop.h * st.ky));
          this.paintSize(true);
        }
      }
      if (e.cancelable) e.preventDefault();
    }

    /* Bakes the current crop into savedCrop (fractions of the full image) and
       regenerates the cropped PNG that goes to the designers. Called when
       leaving the Size step by any route. */
    bakeCrop(){
      var s = this._size;
      if (!s || !s.hasArt || !s.img || !this.crop) return;
      var W = s.img.clientWidth, H = s.img.clientHeight;
      if (!W || !H) return;
      this.state.savedCrop = {
        x: this.crop.x / W, y: this.crop.y / H,
        w: this.crop.w / W, h: this.crop.h / H
      };
      this.state.cropRatio = this.crop.w / this.crop.h;
      this.state.fitMode = 'crop';

      /* Draw the review thumbnail synchronously, here, while the crop image is
         still mounted and decoded. refreshCroppedUpload() below produces the
         same picture but asynchronously (decode → canvas → toBlob), which lands
         after the Review card has already rendered — so relying on it alone
         showed the customer their filename instead of their crop. */
      try {
        var scale = Math.min(1, 900 / Math.max(this.crop.w, this.crop.h));
        var cv = document.createElement('canvas');
        var sx = s.img.naturalWidth / W, sy = s.img.naturalHeight / H;
        cv.width = Math.max(1, Math.round(this.crop.w * scale));
        cv.height = Math.max(1, Math.round(this.crop.h * scale));
        /* CIRCULAR: the cut area is the ellipse inscribed in the crop box, so
           clip the render to it — outside stays transparent PNG. */
        var thumbCtx = cv.getContext('2d');
        clipEllipse(thumbCtx, cv.width, cv.height);
        thumbCtx.drawImage(
          s.img,
          this.crop.x * sx, this.crop.y * sy, this.crop.w * sx, this.crop.h * sy,
          0, 0, cv.width, cv.height
        );
        this._croppedThumb = cv.toDataURL('image/png');
      } catch (e) {
        /* Tainted canvas or a source we can't draw — the async path still runs
           and the order still carries the crop coordinates. */
      }

      /* Drop the pixel crop but keep savedCrop, which is stored as fractions and
         so survives a different image size when the customer comes back to this
         step. initCrop reseeds from it. */
      this.crop = null;
      this._size = null;
      this.refreshCroppedUpload();
    }

    /* ---- person-for-scale figure ---- */
    drawScale(el){
      if (!el) return;
      var VW = 360, VH = 210, groundY = 196;
      var w = this.state.w, h = this.state.h;
      var maxDim = Math.max(w, h);

      /* The stencil in the scale figure is drawn as a blank white rectangle, so
         on its own it reads as a sheet of paper rather than a cut stencil. The
         prototype puts a yellow star on it to say "this is your design, cut
         out". Dropped in the port; Colin caught it 2026-08-20. Scales with the
         stencil but never below a legible floor. */
      var star = function (cxx, cyy, sww, shh, floor) {
        var k = Math.max(floor, Math.min(sww, shh) / 26);
        return '<path transform="translate(' + cxx + ' ' + cyy + ') scale(' + k + ')"' +
          ' d="M0,-10 2.9,-3.1 10,-3.1 4.2,1.2 6.2,8.1 0,4 -6.2,8.1 -4.2,1.2 -10,-3.1 -2.9,-3.1 Z"' +
          ' fill="#FFDE1B" stroke="#141414" stroke-width="1.2"/>';
      };

      if (maxDim <= 10) {
        // Small stencils read better held in a hand at a larger scale.
        var pxi = 14;
        var sw = w * pxi, sh = h * pxi;
        var cx = VW / 2, cyB = 150;
        var sx = cx - sw / 2, syTop = cyB - sh;
        var fw = 9, fgap = 2.5, span = 4 * fw + 3 * fgap;
        var fingers = '';
        for (var i = 0; i < 4; i++) {
          var fx = cx - span / 2 + i * (fw + fgap);
          fingers += '<rect x="' + fx + '" y="' + (cyB - 15) + '" width="' + fw + '" height="21" rx="4.5" fill="#141414"/>';
        }
        el.innerHTML =
          '<svg viewBox="0 0 ' + VW + ' ' + VH + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Hand holding a ' + fmtDim(w) + ' by ' + fmtDim(h) + ' inch circular stencil for scale">' +
          '<rect x="' + (cx - 12) + '" y="' + (cyB + 10) + '" width="24" height="' + (VH - cyB) + '" rx="11" fill="#141414" transform="rotate(8 ' + cx + ' ' + (cyB + 10) + ')"/>' +
          '<ellipse cx="' + cx + '" cy="' + (cyB + 4) + '" rx="21" ry="16" fill="#141414"/>' +
          '<rect x="' + (cx + span / 2 + 1) + '" y="' + (cyB - 13) + '" width="10" height="24" rx="5" fill="#141414" transform="rotate(18 ' + (cx + span / 2 + 1) + ' ' + (cyB - 13) + ')"/>' +
          '<ellipse cx="' + (sx + sw / 2) + '" cy="' + (syTop + sh / 2) + '" rx="' + (sw / 2) + '" ry="' + (sh / 2) + '" fill="#ffffff" stroke="#141414" stroke-width="2.5"/>' +
          star(cx, syTop + sh / 2, sw, sh, 0.35) +
          fingers + '</svg>';
        return;
      }

      var pxPerIn = 2.45;
      var personH = 68 * pxPerIn;      // a 5'8" figure, labelled below
      var sw2 = w * pxPerIn, sh2 = h * pxPerIn;
      var px = VW / 2;
      var headY = groundY - personH + 11;
      var shoulderY = headY + 22;
      var sx2 = px - sw2 / 2;
      var chestCenter = headY + 52;
      var syTop2 = (sh2 <= 92) ? Math.max(8, chestCenter - sh2 / 2) : groundY - sh2;
      var syBot = syTop2 + sh2;
      var handY = Math.min(Math.max(shoulderY + 26, syTop2 + 10), syBot - 8);
      /* CIRCULAR: the hands grip the ELLIPSE's edge at hand height, not the
         bounding box's corner-height edge — on a circle those differ, and
         box-edge hands float in the air beside the stencil. */
      var eMidY = syTop2 + sh2 / 2;
      var eT = (handY - eMidY) / (sh2 / 2);
      if (eT > 0.92) eT = 0.92;
      if (eT < -0.92) eT = -0.92;
      var eHalfW = (sw2 / 2) * Math.sqrt(Math.max(0, 1 - eT * eT));
      var lx = px - eHalfW - 1, rx = px + eHalfW + 1;

      el.innerHTML =
        '<svg viewBox="0 0 ' + VW + ' ' + VH + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Person 5 foot 8 holding a ' + fmtDim(w) + ' by ' + fmtDim(h) + ' inch circular stencil in front of them for scale">' +
        '<line x1="8" y1="' + groundY + '" x2="' + (VW - 8) + '" y2="' + groundY + '" stroke="#141414" stroke-width="2.5" stroke-linecap="round"/>' +
        '<text x="' + (VW - 10) + '" y="' + (groundY - 7) + '" text-anchor="end" font-size="11" font-weight="600" fill="#b5b2a9">Person is 5\'8"</text>' +
        '<g fill="#141414">' +
          '<circle cx="' + px + '" cy="' + headY + '" r="11"/>' +
          '<rect x="' + (px - 10) + '" y="' + (headY + 13) + '" width="20" height="58" rx="9"/>' +
          '<rect x="' + (px - 8.5) + '" y="' + (headY + 68) + '" width="7" height="' + (personH - 90) + '" rx="3.5"/>' +
          '<rect x="' + (px + 1.5) + '" y="' + (headY + 68) + '" width="7" height="' + (personH - 90) + '" rx="3.5"/>' +
        '</g>' +
        '<g stroke="#141414" stroke-width="6.5" stroke-linecap="round" fill="none">' +
          '<path d="M' + (px - 9) + ',' + shoulderY + ' L' + lx + ',' + handY + '"/>' +
          '<path d="M' + (px + 9) + ',' + shoulderY + ' L' + rx + ',' + handY + '"/>' +
        '</g>' +
        '<ellipse cx="' + px + '" cy="' + (syTop2 + sh2 / 2) + '" rx="' + (sw2 / 2) + '" ry="' + (sh2 / 2) + '" fill="#ffffff" stroke="#141414" stroke-width="2.5"/>' +
        star(px, syTop2 + sh2 / 2, sw2, sh2, 0.3) +
        '<g fill="#141414"><circle cx="' + lx + '" cy="' + handY + '" r="5"/><circle cx="' + rx + '" cy="' + handY + '" r="5"/></g>' +
        '</svg>';
    }

    /* ==================================================================
       STEP 3 · QUANTITY
    ================================================================== */
    renderQty(card){
      var self = this;
      card.innerHTML =
        '<h2 class="pricer-h2">How many?</h2>' +
        '<p class="pricer-sub">Identical copies of the same design. Buy more, save more.</p>' +
        '<div class="pricer-qtyrow">' +
          '<button type="button" class="pricer-qbtn" data-role="minus" aria-label="Decrease quantity">−</button>' +
          '<input class="nospin" data-role="qtyin" type="number" min="1" max="' + MAX_QTY + '" inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" class="pricer-qbtn" data-role="plus" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<p class="pricer-nudge-line" data-role="nudge"></p>' +
        '<div class="pricer-tiers" data-role="tiers" aria-live="polite"></div>';

      var input = card.querySelector('[data-role="qtyin"]');
      card.querySelector('[data-role="minus"]').addEventListener('click', function () { self.setQty(self.state.qty - 1); });
      card.querySelector('[data-role="plus"]').addEventListener('click', function () { self.setQty(self.state.qty + 1); });
      input.addEventListener('input', function () {
        var v = parseInt(input.value, 10);
        if (Number.isFinite(v)) self.setQty(v, true);
      });
      this._qty = { card: card, input: input };
      this.addNav(card, { backOk: true });
      this.paintQty();
    }

    setQty(q, fromInput){
      var was = this.state.qty;
      this.state.qty = Math.min(MAX_QTY, Math.max(1, q || 1));
      /* The designer SVG prints the quantity on the artboard, but it is built
         on the Size step — which comes BEFORE this one, so it captures qty 1
         and every multi-unit order shipped a label reading "qty 1". Found on
         live order #56462. Same staleness rule as the design name: mark it,
         and Add to Cart regenerates once. */
      if (this.state.qty !== was) this._svgStale = true;
      this.paintQty(fromInput);
    }

    paintQty(fromInput){
      this.el.qty.value = this.state.qty;   // the real submitted field
      if (!this._qty || this.stepName() !== 'Qty') { this.updatePrice(); return; }
      var card = this._qty.card;
      if (!fromInput) this._qty.input.value = this.state.qty;
      card.querySelector('[data-role="minus"]').disabled = this.state.qty <= 1;

      /* "Add N more to save X%" — N and X both point at the next quantity band,
         so the nudge and the table below it are describing the same jump. */
      var nudge = card.querySelector('[data-role="nudge"]');
      var nt = nextTier(this.state.qty);
      if (!quote(this.state.w, this.state.h, this.state.qty)) {
        nudge.textContent = '';
      } else if (nt) {
        var gap = nt.min - this.state.qty;
        nudge.textContent = 'Add ' + gap + ' more to save ' +
          tierPct(this.state.w, this.state.h, nt.min) + '%';
      } else {
        nudge.textContent = "You're at max savings";
      }

      this.renderTiers(card.querySelector('[data-role="tiers"]'));
      this.updatePrice();
    }

    /* The volume table from the prototype: every band always visible, the one
       the current quantity falls in highlighted, each row a shortcut to that
       band's entry quantity. */
    renderTiers(el){
      if (!el) return;
      el.textContent = '';
      if (!quote(this.state.w, this.state.h, this.state.qty)) {
        el.innerHTML = '<div class="pricer-tier"><span>Pick a size first</span></div>';
        return;
      }
      var self = this;
      var active = tierFor(this.state.qty);
      QTY_TIERS.forEach(function (t) {
        var pct = tierPct(self.state.w, self.state.h, t.min);
        var row = document.createElement('div');
        row.className = 'pricer-tier' + (t === active ? ' is-on' : '');
        /* "1 stencils" read as broken on the live phone run. The label is the
           band, not a count, so only the single-unit band is ever singular. */
        row.innerHTML = '<span>' + t.label + (t.label === '1' ? ' stencil' : ' stencils') + '</span>' +
          '<span class="pct">' + (pct > 0 ? pct + '% off' : '—') + '</span>';
        row.addEventListener('click', function () { self.setQty(t.min); });
        el.appendChild(row);
      });
    }

    /* ==================================================================
       STEP 4 · REVIEW & DETAILS
    ================================================================== */
    renderDetails(card){
      var self = this;
      var u = quote(this.state.w, this.state.h, this.state.qty);

      /* Size preview: Custom Mylar (Colin, 2026-10-13) and Custom Adhesive
         (2026-10-14, "Let's also do it on adhesive"). The snippet sets
         data-size-preview on those two products by handle; the pricers
         generated from this file (circle, metal, coffee) never match, so they
         keep the one-line Size row. The "Review" heading is NOT gated: every
         pricer's last step reads "Review" on the bar, the button and the card
         (Colin, 2026-10-14: "they all need to match exactly"). */
      var sizePreview = this.hasAttribute('data-size-preview');
      var artRow = '';
      if (this.state.artUploaded && this.state.previewable && this._croppedThumb) {
        artRow = '<div class="row"><span class="k">Design</span>' +
          '<span><img class="pricer-thumb is-clickable" data-role="thumb" src="' + esc(this._croppedThumb) + '" alt="Cropped preview — tap to see the crop on your full image" title="Tap to see the crop on your full image"></span></div>';
      } else if (this.state.artUploaded) {
        artRow = '<div class="row"><span class="k">Design</span><span>' + esc(this._fileName || 'Your file') +
          '<button type="button" class="pricer-editlink" data-role="edArt">Change</button></span></div>';
      } else if (this.state.sendLater) {
        artRow = '<div class="row"><span class="k">Design</span><span>Emailing artwork after ordering' +
          '<button type="button" class="pricer-editlink" data-role="edArt">Change</button></span></div>';
      }

      card.innerHTML =
        '<h2 class="pricer-h2">Review</h2>' +
        '<p class="pricer-sub">Check your order and tell us about your project.</p>' +
        '<div class="pricer-review">' +
          artRow +
          /* The fallback line is kept verbatim: build-coffee-pricer.js anchors on it. */
          (sizePreview ? sizeRowHtml(this.state.w, this.state.h) :
          '<div class="row"><span class="k">Size</span><span>' + fmtDim(this.state.w) + '" × ' + fmtDim(this.state.h) + '"' +
            '<button type="button" class="pricer-editlink" data-role="edSize">Edit</button></span></div>') +
          '<div class="row"><span class="k">Quantity</span><span>' + this.state.qty +
            '<button type="button" class="pricer-editlink" data-role="edQty">Edit</button></span></div>' +
          (u ? '<div class="row"><span class="k">Per stencil</span><span>' + esc(money(u.unit)) + '</span></div>' : '') +
          (u ? '<div class="row"><span class="k">Total</span><span class="pricer-reviewtotal">' + esc(money(u.total)) + '</span></div>' : '') +
        '</div>' +
        /* The "This exact cropped preview goes to our designers" note was
           removed here 2026-08-21 (Colin). */
        '<button type="button" class="pricer-reflink" data-role="detToggle">+ Add project details (optional)</button>' +
        '<div class="pricer-details" data-role="detBody">' +
          '<div class="pricer-field"><label for="pricer-dname-' + this.dataset.uid + '">Name your design</label>' +
            '<input id="pricer-dname-' + this.dataset.uid + '" type="text" name="properties[𝗗𝗲𝘀𝗶𝗴𝗻 𝗻𝗮𝗺𝗲]" data-role="dname" placeholder="e.g. Elk logo v2"></div>' +
          '<div class="pricer-field"><label for="pricer-pinfo-' + this.dataset.uid + '">Anything we should know? <span class="label-hint">(surfaces, deadlines, tricky spots)</span></label>' +
            '<textarea id="pricer-pinfo-' + this.dataset.uid + '" name="properties[𝗣𝗿𝗼𝗷𝗲𝗰𝘁 𝗗𝗲𝘁𝗮𝗶𝗹𝘀]" data-role="pinfo"></textarea></div>' +
          '<div class="pricer-field"><label for="pricer-ig-' + this.dataset.uid + '">Instagram @ <span class="label-hint">(we\'ll tag you)</span></label>' +
            '<input id="pricer-ig-' + this.dataset.uid + '" type="text" name="properties[𝗜𝗻𝘀𝘁𝗮𝗴𝗿𝗮𝗺]" data-role="ig" placeholder="@yourhandle"></div>' +
        '</div>';

      /* The detail fields are recreated with the card, so their typed values are
         carried in state rather than left to the DOM. */
      var dname = card.querySelector('[data-role="dname"]');
      var pinfo = card.querySelector('[data-role="pinfo"]');
      var ig = card.querySelector('[data-role="ig"]');
      if (!this._dname && this._fileName) this._dname = this._fileName.replace(/\.[^.]+$/, '');
      dname.value = this._dname || '';
      pinfo.value = this._pinfo || '';
      ig.value = this._ig || '';
      dname.addEventListener('input', function () {
        self._dname = this.value;
        /* The designer SVG carries this name in its on-artboard label, but it
           was generated back on the Size step. Rebuilding per keystroke would
           re-encode the whole image, so just mark it stale — Add to Cart
           regenerates once, below. */
        self._svgStale = true;
      });
      pinfo.addEventListener('input', function () { self._pinfo = this.value; });
      ig.addEventListener('input', function () { self._ig = this.value; });

      var body = card.querySelector('[data-role="detBody"]');
      body.classList.toggle('show', this.state.detailsOpen);
      card.querySelector('[data-role="detToggle"]').addEventListener('click', function () {
        self.state.detailsOpen = !self.state.detailsOpen;
        body.classList.toggle('show', self.state.detailsOpen);
        this.textContent = self.state.detailsOpen ? '− Hide project details' : '+ Add project details (optional)';
      });

      var edSize = card.querySelector('[data-role="edSize"]');
      var edQty = card.querySelector('[data-role="edQty"]');
      var edArt = card.querySelector('[data-role="edArt"]');
      if (edSize) edSize.addEventListener('click', function () { self.jumpTo(STEPS.indexOf('Size')); });
      if (edQty) edQty.addEventListener('click', function () { self.jumpTo(STEPS.indexOf('Qty')); });
      if (edArt) edArt.addEventListener('click', function () { self.jumpTo(STEPS.indexOf('Upload')); });
      var sizePrev = card.querySelector('[data-role="sizePreview"]');
      if (sizePrev) sizePrev.addEventListener('click', function () {
        openSizePreview(self.state.w, self.state.h, sizePrev);
      });

      var thumb = card.querySelector('[data-role="thumb"]');
      if (thumb) thumb.addEventListener('click', function () { self.openCropReview(); });

      // The real Add to Cart button and its note, moved in rather than rebuilt.
      this.addNav(card, { backOk: true, node: this.el.atcBtn });
      card.appendChild(this.el.atcNote);
      this.refreshGate();
    }

    openCropReview(){
      if (!this.el.cropModal || !this.state.fullSrc || !this.state.savedCrop) return;
      var c = this.state.savedCrop;
      var img = this.el.cropModalImg, box = this.el.cropModalBox;
      var place = function () {
        box.style.left = (c.x * 100) + '%';
        box.style.top = (c.y * 100) + '%';
        box.style.width = (c.w * 100) + '%';
        box.style.height = (c.h * 100) + '%';
      };
      if (img.src !== this.state.fullSrc) { img.onload = place; img.src = this.state.fullSrc; }
      else place();
      this.el.cropModal.classList.add('show');
      document.body.classList.add('pricer-lock');
    }

    /* ==================================================================
       PRICE + GATE
    ================================================================== */
    updatePrice(){
      var card = this.el.cardhost.firstChild;
      var totalEl = card && card.querySelector('[data-role="cardtotal"]');
      if (totalEl) {
        // No price for an under-minimum size: the table would quietly price it as the minimum.
        var u = this.sizeError() ? null : quote(this.state.w, this.state.h, this.state.qty);
        totalEl.textContent = u ? money(u.total) : '—';
      }
      this.refreshGate();
    }

    refreshGate(){
      var artworkChosen = this.state.artUploaded || this.state.sendLater;
      var needsAck = this.state.artUploaded && !this.state.previewable;
      var acked = !needsAck || (this.el.noPreviewAck && this.el.noPreviewAck.checked);
      var sized = !this.sizeError() && !!quote(this.state.w, this.state.h, this.state.qty);

      this.el.atcBtn.disabled = !artworkChosen || !acked || !sized;
      this.el.atcNote.textContent = !artworkChosen
        ? (this.state.uploadError || "Choose how you'll send your artwork to continue")
        : !acked ? 'Confirm the note above so we know how to proof your file'
        : !sized ? 'Pick a size to see your price'
        : '';

      if (this.stepName() === 'Upload') this.paintUpload();
    }

    /* ==================================================================
       ARTWORK
    ================================================================== */
    onFileChosen(f){
      if (!f) return;
      var self = this;

      /* Shopify rejects line-item property files over 20MB. Catch it here with
         a clear message rather than letting Add to Cart fail at the last step,
         after the customer has configured everything. */
      if (f.size > MAX_UPLOAD_BYTES) {
        this.el.fileInput.value = '';
        this.clearArtwork();
        this.state.uploadError = 'That file is ' + (f.size / 1048576).toFixed(0) +
          'MB. Files over 20MB can’t be attached to an order — send a smaller version, or choose "Email it after ordering" below.';
        this.paintUpload();
        this.refreshGate();
        return;
      }

      /* Kept so the designer SVG can size its embedded copy against what the
         original is already costing this request — see encodeArtworkForSvg. */
      this._fileBytes = f.size;

      this.state.uploadError = null;
      this.state.artUploaded = true;
      this.state.sendLater = false;
      this.state.pausedUpload = null;
      /* Clear the OLD file's measurements too — leaving them meant the shape
         check ran against the previous artwork until the new one loaded. */
      this.state.artW = null; this.state.artH = null; this.state.fullSrc = null;
      this.state.previewable = false; this.state.savedCrop = null; this.state.cropRatio = null;
      this.state.fitMode = null;
      this.crop = null;
      this._croppedThumb = null;
      if (this.el.croppedInput) this.el.croppedInput.value = '';
      if (this.el.designerInput) this.el.designerInput.value = '';
      if (this.el.noPreviewAck) this.el.noPreviewAck.checked = false;

      this._fileName = f.name;
      this._fileStatus = 'Reading your file…';
      if (!this._dname) this._dname = f.name.replace(/\.[^.]+$/, '');
      /* Identifies this upload for the rest of its life. A second file chosen
         while this one is still decoding bumps the counter, which is how the
         late arrival of the first is recognised and ignored — see
         maybeAutoAdvance. */
      this._uploadSeq = (this._uploadSeq || 0) + 1;
      var seq = this._uploadSeq;
      this.paintUpload();

      if (f.type.indexOf('image/') === 0) {
        /* Exactly one of these outcomes may land. Before this flag the watchdog
           below could write off a file that was merely slow, undoing a decode
           that then completed a moment later. */
        var settled = false;
        var settle = function (fn) {
          return function () {
            if (settled || seq !== self._uploadSeq) return;
            settled = true;
            fn.apply(null, arguments);
          };
        };

        var fr = new FileReader();
        fr.onload = function () {
          var img = new Image();
          img.onload = settle(function () {
            self.state.artW = img.naturalWidth;
            self.state.artH = img.naturalHeight;
            self.state.fullSrc = fr.result;
            self.state.previewable = true;
            self._fileStatus = null;   // the thumbnail is the confirmation
            self.paintUpload();
            self.refreshGate();
            self.maybeAutoAdvance(seq);
          });
          img.onerror = settle(function () { self.decodeViaBitmap(f, seq); });
          img.src = fr.result;
        };
        fr.onerror = settle(function () { self.decodeViaBitmap(f, seq); });
        fr.readAsDataURL(f);

        /* A phone photo can put an <img> into a state where NEITHER callback
           ever fires — a data URL past the size Safari will take as an img src
           is the usual way in — and the customer is then left on "Reading your
           file…" for good, with the step never advancing and no way to tell
           why. The second-chance decode below handles the same files properly;
           this is only here so that a silent stall becomes one. */
        window.setTimeout(settle(function () { self.decodeViaBitmap(f, seq); }), DECODE_TIMEOUT_MS);
      } else if (isPdfLike(f)) {
        /* PDF and .ai (which carry a PDF stream when saved with "Create PDF
           Compatible File") render via PDF.js. Without this these skipped the
           proportion check entirely — exactly the class of order that causes
           production problems. */
        this.renderPdfPreview(f);
      } else {
        /* BUG FIX (v2 prototype): it dropped anything that wasn't an image
           silently — no message, nothing happened — while advertising AI, EPS,
           PDF, PSD and TIFF on the button. Same silent-rejection shape as the
           old iPhone upload bug. EPS and PSD genuinely can't be rasterised in a
           browser, so they take the acknowledged path rather than vanishing. */
        this.markUnpreviewable();
      }
    }

    /* Second chance for a file the <img> route refused, before it is written
       off as unpreviewable — which costs the customer the thumbnail, the shape
       check and the crop, and (by design) parks them on Upload behind the
       acknowledgement tickbox. That is the right ending for a PSD or an EPS; it
       is the wrong one for a photo, and on a phone photos are what land here:

         HEIC        the accept list names .heic/.heif, so iOS hands over the
                     original from the Photo Library instead of transcoding it
                     to JPEG. createImageBitmap goes through the platform
                     decoders, so on an iPhone this simply works.
         big photos  a full-resolution camera JPEG becomes a data URL past what
                     Safari will accept as an img src. A Blob has no such limit.

       Where the browser genuinely cannot decode the file — a real PSD, or a
       HEIC on Android — this rejects and we land exactly where we do today. */
    decodeViaBitmap(f, seq){
      var self = this;
      if (typeof createImageBitmap !== 'function' || !window.URL || !URL.createObjectURL) {
        this.markUnpreviewable();
        return;
      }
      createImageBitmap(f).then(function (bm) {
        /* Checked again on the way out: this is async, and a second file chosen
           while it ran must not be overwritten by this one's measurements. */
        if (seq !== self._uploadSeq) return;

        /* Read BEFORE close() — a closed ImageBitmap reports 0x0, and these two
           are the ORIGINAL pixel dimensions, not the canvas ones. artW/artH
           drive the shape check against the ordered size, so they have to
           describe the customer's actual file, not our downscaled copy. */
        var srcW = bm.width, srcH = bm.height;

        var scale = Math.min(1, FALLBACK_MAX_EDGE / Math.max(srcW, srcH));
        var cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(srcW * scale));
        cv.height = Math.max(1, Math.round(srcH * scale));
        cv.getContext('2d').drawImage(bm, 0, 0, cv.width, cv.height);
        if (bm.close) bm.close();

        self.state.artW = srcW;
        self.state.artH = srcH;
        self.state.fullSrc = cv.toDataURL('image/jpeg', 0.92);
        self.state.previewable = true;
        self._fileStatus = null;
        self.paintUpload();
        self.refreshGate();
        self.maybeAutoAdvance(seq);
      }).catch(function () {
        if (seq === self._uploadSeq) self.markUnpreviewable();
      });
    }

    markUnpreviewable(){
      this.state.artW = null; this.state.artH = null;
      this.state.fullSrc = null; this.state.previewable = false;
      this._fileStatus = '✓ Uploaded — we’ll check it by hand';
      this.paintUpload();
      this.refreshGate();
    }

    /* Rasterises page 1 so the artwork can be measured and cropped like any
       image. PDF.js is ~370KB so it is only fetched once a PDF or .ai is
       actually chosen, never on page load. */
    async renderPdfPreview(f){
      var self = this;
      /* Read before the first await, so it is this upload's number and not
         whatever a later file has since set it to. */
      var seq = this._uploadSeq;
      try {
        var lib = await loadPdfJs(this.dataset.pdfjs, this.dataset.pdfjsWorker);
        var buf = await f.arrayBuffer();
        var doc = await lib.getDocument({ data: buf }).promise;
        var page = await doc.getPage(1);
        var base = page.getViewport({ scale: 1 });
        /* Cap the raster so a large-format PDF doesn't blow up memory, but keep
           it detailed enough to crop against. */
        var scale = Math.min(2, 1600 / Math.max(base.width, base.height));
        var vp = page.getViewport({ scale: scale });
        var cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(vp.width));
        cv.height = Math.max(1, Math.round(vp.height));
        await page.render({ canvasContext: cv.getContext('2d'), viewport: vp }).promise;

        self.state.artW = cv.width;
        self.state.artH = cv.height;
        self.state.fullSrc = cv.toDataURL('image/png');
        self.state.previewable = true;
        self._fileStatus = null;   // the thumbnail is the confirmation
        self.paintUpload();
        self.refreshGate();
        self.maybeAutoAdvance(seq);
      } catch (err) {
        /* Encrypted, corrupt, or a non-PDF-compatible .ai — fall back to the
           acknowledged path rather than leaving the customer stuck. */
        self.markUnpreviewable();
      }
    }

    /* Renders exactly what the customer selected — the crop applied to the
       artwork — and uploads it alongside the original file. Crop coordinates on
       their own are unusable by a designer; this is the selection as a picture.

       Returns a Promise that resolves once croppedInput.files is actually set.
       Tracked on _artworkReady as well as returned, because callers vary in
       whether they await it — Add to Cart is the one place that MUST wait, and
       it does so regardless of which caller started the rebuild. */
    refreshCroppedUpload(){
      var self = this;
      if (!this.state.fullSrc || !this.el.croppedInput) return Promise.resolve();
      var promise = new Promise(function (resolve) {
        var im = new Image();
        im.onload = function () {
          var s = self.state.savedCrop || { x: 0, y: 0, w: 1, h: 1 };
          var sw = Math.max(1, Math.round(s.w * im.naturalWidth));
          var sh = Math.max(1, Math.round(s.h * im.naturalHeight));
          /* Cap the long edge — a full-resolution crop of a large scan would
             balloon the upload for no benefit; the original carries the detail. */
          var scale = Math.min(1, 2000 / Math.max(sw, sh));
          var cv = document.createElement('canvas');
          cv.width = Math.max(1, Math.round(sw * scale));
          cv.height = Math.max(1, Math.round(sh * scale));
          /* CIRCULAR: clip the designers' cropped PNG to the ellipse — this
             file is "exactly what the customer selected", and what they
             selected is the oval. Outside stays transparent. */
          var cropCtx = cv.getContext('2d');
          clipEllipse(cropCtx, cv.width, cv.height);
          cropCtx.drawImage(
            im, s.x * im.naturalWidth, s.y * im.naturalHeight, sw, sh, 0, 0, cv.width, cv.height
          );
          self._croppedThumb = cv.toDataURL('image/png');

          /* Built from the same loaded image and the same crop fractions, in
             the same pass, so the frame can never describe a different crop
             than the preview does. Rides inside this promise deliberately —
             _artworkReady then gates Add to Cart on the SVG too. */
          self.attachDesignerSvg(im, s);
          self._svgStale = false;

          if (!cv.toBlob) { resolve(); return; }
          cv.toBlob(function (blob) {
            if (!blob) { resolve(); return; }
            try {
              var dt = new DataTransfer();
              dt.items.add(new File([blob], 'cropped-artwork.png', { type: 'image/png' }));
              self.el.croppedInput.files = dt.files;
            } catch (e) {
              /* Older browsers can't build a File list programmatically. The
                 original file and the crop coordinates still go through. */
            }
            resolve();
          }, 'image/png');
        };
        im.onerror = function () { resolve(); };   // don't hang the caller on a bad fullSrc
        im.src = self.state.fullSrc;
      });
      this._artworkReady = promise;
      return promise;
    }

    /* ------------------------------------------------------------------
       DESIGNER SVG — one self-contained file replacing the designer's need
       to guess which of two near-identical attachments is the source.

       Two top-level groups, because Illustrator maps them to layers: the
       artwork, and a crop frame the designer hides or deletes. The file
       declares its size in INCHES such that the crop region measures the
       ordered size on the artboard — open it and the frame is already at
       production scale, no measuring.

       Colin, 2026-08-20: the frame measures the DESIGN (the priced width ×
       height), not the sheet with its 1" border per side. Designers are on
       current Illustrator CC.
    ------------------------------------------------------------------ */

    /* The embedded raster is state.fullSrc — the canvas re-encode, NOT the
       customer's original bytes. That is deliberate on two counts:

       1. Orientation. A phone photo carries EXIF rotation. Canvas decoding
          applies it; SVG <image> does not. Embedding the raw file would open
          sideways in Illustrator with the frame over the wrong region — and
          savedCrop's fractions are measured against the oriented image, so
          artwork and frame would disagree. The re-encode is already oriented,
          which keeps the two in the same space by construction.
       2. Size. The original may be 20MB; base64 adds a third on top, and this
          rides alongside two other attachments.

       Falls back to JPEG, then to progressively smaller JPEGs, when the PNG
       blows the budget. Returns null if even the smallest won't fit, and the
       caller then simply doesn't attach an SVG — the original and the cropped
       preview still go through, exactly as before this existed. */
    /* The SVG is the THIRD file in the same cart POST, behind the original and
       the cropped preview. Shopify's 20MB is per file, but the request still
       has to complete on a phone connection — so the budget shrinks as the
       original grows rather than being a flat number that happens to pass on a
       small upload and stalls checkout on a big one. */
    svgArtworkBudget(){
      var spent = this._fileBytes || 0;
      return Math.max(3 * 1024 * 1024, Math.min(SVG_ARTWORK_BUDGET, 18 * 1024 * 1024 - spent));
    }

    encodeArtworkForSvg(im){
      var SVG_ARTWORK_BUDGET = this.svgArtworkBudget();
      if (this.state.fullSrc && this.state.fullSrc.length <= SVG_ARTWORK_BUDGET) {
        return this.state.fullSrc;
      }
      var natW = im.naturalWidth, natH = im.naturalHeight;
      var scale = 1;
      for (var i = 0; i < 5; i++) {
        var cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(natW * scale));
        cv.height = Math.max(1, Math.round(natH * scale));
        var ctx = cv.getContext('2d');
        /* JPEG has no alpha. Without this, a transparent PNG or a cut-out
           logo bakes to solid black and the designer opens a black square. */
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, cv.width, cv.height);
        ctx.drawImage(im, 0, 0, cv.width, cv.height);
        var href;
        try { href = cv.toDataURL('image/jpeg', 0.92); } catch (e) { return null; }
        if (href.length <= SVG_ARTWORK_BUDGET) return href;
        scale *= 0.7;
      }
      return null;
    }

    buildDesignerSvg(im, s){
      var natW = im.naturalWidth, natH = im.naturalHeight;
      if (!natW || !natH || !s.w || !s.h) return null;

      var href = this.encodeArtworkForSvg(im);
      if (!href) return null;

      var cx = s.x * natW, cy = s.y * natH;
      var cw = s.w * natW, ch = s.h * natH;
      /* CIRCULAR: the frame layer is the ellipse inscribed in the crop box. */
      var eCx = cx + cw / 2, eCy = cy + ch / 2, eRx = cw / 2, eRy = ch / 2;

      /* The whole point: declare the page in inches so that the CROP measures
         the ordered size. Full image inches = ordered ÷ the crop's fraction of
         it. Kept at four decimals — rounding this to two would put the frame
         out by a few thousandths of an inch for no benefit. */
      var inW = this.state.w / s.w;
      var inH = this.state.h / s.h;

      /* A small crop of a big image implies a huge page: 8% of the width at a
         48" order is a 600-inch artboard, past Illustrator's 227.54" ceiling,
         and the file simply won't open at that size. Scale the whole thing
         down uniformly and say so on the artboard — a file that opens with the
         scale stated beats a file that opens at 1:1 or not at all. */
      var MAX_ARTBOARD_IN = 220;
      var over = Math.max(inW, inH) / MAX_ARTBOARD_IN;
      var scaleNote = '';
      if (over > 1) {
        inW /= over;
        inH /= over;
        scaleNote = ' · NOT AT SIZE — shown at 1:' + (Math.round(over * 1000) / 1000) +
          ', cut to the stated size above';
      }
      inW = Math.round(inW * 10000) / 10000;
      inH = Math.round(inH * 10000) / 10000;

      /* Scale the frame furniture to the image so it is neither invisible on a
         400px upload nor comically thick on an 8000px one. */
      var sw = Math.max(2, natW * 0.004);
      var fs = Math.max(14, natW * 0.02);

      /* Above the frame normally; inside it when the crop is hard against the
         top edge, where an outside label would sit off the artboard. */
      var labelY = (cy - sw * 2 >= fs * 1.2) ? (cy - sw * 2) : (cy + fs * 1.4);

      /* CIRCULAR: name the shape on the artboard — Width/Height alone don't. */
      var shapeWord = Math.abs(this.state.w - this.state.h) < 0.001 ? ' circle' : ' oval';
      var label = fmtDim(this.state.w) + '" × ' + fmtDim(this.state.h) + '"' + shapeWord +
        ' · qty ' + this.state.qty +
        (this._dname ? ' · ' + this._dname : '') + scaleNote;

      /* Text-node escaping, not attribute escaping. esc() also converts quotes
         to &quot;, which is valid XML but leaves the inch marks written as
         entities in a file a human opens and reads. Only & and < can actually
         break a text node. */
      var labelXml = String(label).replace(/&/g, '&amp;').replace(/</g, '&lt;');

      return '<?xml version="1.0" encoding="UTF-8"?>\n' +
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n' +
        '     width="' + inW + 'in" height="' + inH + 'in" viewBox="0 0 ' + natW + ' ' + natH + '">\n' +
        '  <g id="artwork">\n' +
        '    <image xlink:href="' + href + '" x="0" y="0" width="' + natW + '" height="' + natH + '"/>\n' +
        '  </g>\n' +
        '  <g id="CROP-FRAME--DO-NOT-PRINT">\n' +
        '    <path d="M0,0 H' + natW + ' V' + natH + ' H0 Z M' + cx + ',' + eCy +
                 ' a ' + eRx + ',' + eRy + ' 0 1,0 ' + cw + ',0' +
                 ' a ' + eRx + ',' + eRy + ' 0 1,0 ' + (-cw) + ',0 Z"\n' +
        '          fill="#141414" fill-opacity="0.45" fill-rule="evenodd"/>\n' +
        '    <ellipse cx="' + eCx + '" cy="' + eCy + '" rx="' + eRx + '" ry="' + eRy + '"\n' +
        '          fill="none" stroke="#FFDE1B" stroke-width="' + sw + '"/>\n' +
        '    <text x="' + (cx + sw * 2) + '" y="' + labelY + '"\n' +
        '          font-family="Arial, Helvetica, sans-serif" font-size="' + fs + '" font-weight="bold"\n' +
        '          fill="#FFDE1B" stroke="#141414" stroke-width="' + (fs * 0.06) + '" paint-order="stroke">' +
                 labelXml + '</text>\n' +
        '  </g>\n' +
        '</svg>\n';
    }

    attachDesignerSvg(im, s){
      if (!this.el.designerInput) return;
      var svg;
      try { svg = this.buildDesignerSvg(im, s); } catch (e) { svg = null; }
      if (!svg) { this.el.designerInput.value = ''; return; }
      try {
        var name = (this._dname || 'stencil-order')
          .replace(/[^a-z0-9_-]+/gi, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'stencil-order';
        var dt = new DataTransfer();
        dt.items.add(new File([svg], name + '-designer.svg', { type: 'image/svg+xml' }));
        this.el.designerInput.files = dt.files;
      } catch (e) {
        /* Older browsers can't build a FileList. The original and the cropped
           preview still go through — this file is an addition, never a
           replacement, so losing it costs the designer convenience, not data. */
        this.el.designerInput.value = '';
      }
    }

    toggleSendLater(){
      this.state.sendLater = !this.state.sendLater;
      if (this.state.sendLater) {
        /* Snapshot rather than discard: clicking "undo" a moment later used to
           bring back an empty upload zone instead of the file already chosen,
           because there was nothing left to restore. Flagged by Colin,
           2026-08-12. The real file in fileInput is untouched throughout — only
           the derived measurements and the visible state are parked here. */
        if (this.state.artUploaded) {
          this.state.pausedUpload = {
            artW: this.state.artW, artH: this.state.artH,
            fullSrc: this.state.fullSrc, previewable: this.state.previewable,
            savedCrop: this.state.savedCrop, cropRatio: this.state.cropRatio,
            fitMode: this.state.fitMode,
            fileName: this._fileName, fileStatus: this._fileStatus,
            croppedThumb: this._croppedThumb
          };
        }
        this.state.artUploaded = false;
        this.state.artW = null; this.state.artH = null;
        this.state.fullSrc = null; this.state.previewable = false;
        this.state.savedCrop = null; this.state.cropRatio = null;
        this.state.fitMode = null;
        this.crop = null;
        if (this.el.croppedInput) this.el.croppedInput.value = '';
        if (this.el.designerInput) this.el.designerInput.value = '';
        if (this.el.noPreviewAck) this.el.noPreviewAck.checked = false;
      } else {
        var p = this.state.pausedUpload;
        if (p) {
          this.state.artUploaded = true;
          this.state.artW = p.artW; this.state.artH = p.artH;
          this.state.fullSrc = p.fullSrc; this.state.previewable = p.previewable;
          this.state.savedCrop = p.savedCrop; this.state.cropRatio = p.cropRatio;
          this.state.fitMode = p.fitMode;
          this._fileName = p.fileName; this._fileStatus = p.fileStatus;
          this._croppedThumb = p.croppedThumb;
          this.state.pausedUpload = null;
          this.refreshCroppedUpload();   // rebuild the cropped file from the restored source
        }
      }
      this.paintUpload();
      this.refreshGate();
    }

    /* Horizontal chip rows are drag-scrollable with a mouse; the returned
       function reports whether the last gesture was a drag, so a drag doesn't
       also register as a tap on whichever chip it ended over. */
    enableDragScroll(el){
      var isDown = false, startX = 0, scrollLeft = 0, moved = false;
      el.addEventListener('mousedown', function (e) { isDown = true; moved = false; startX = e.pageX; scrollLeft = el.scrollLeft; });
      el.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 4) moved = true;
        el.scrollLeft = scrollLeft - dx;
      });
      ['mouseup', 'mouseleave'].forEach(function (ev) {
        el.addEventListener(ev, function () { isDown = false; setTimeout(function () { moved = false; }, 0); });
      });
      return function () { return moved; };
    }

    /* ==================================================================
       ADD TO CART — unchanged from v1 apart from where state lives.
       Read the file header before touching any of this.
    ================================================================== */
    async handleAddToCart(){
      if (this.el.atcBtn.disabled) return;
      // Never reached in practice (the button is disabled), but never clamp a flagged size into the cart.
      if (this.sizeError()) { this.jumpTo(STEPS.indexOf('Size')); return; }
      /* Clicking here fires focusout on whichever size field was still focused,
         but that field's finalize is deliberately deferred so it doesn't clamp
         while the customer is mid-entry. The deferred check hasn't run yet at
         this point in the same synchronous click — so clamp here too,
         synchronously, as the last gate before anything is priced or submitted. */
      this.state.w = clampDim(this.state.w);
      this.state.h = clampDim(this.state.h);
      this.syncProperties();

      var self = this;
      var settled = false;
      var timer = null;
      /* Guarded and idempotent: the button used to reset ONLY on the theme's
         cart:change / cart:error events, so if neither ever fired the customer
         was left with a permanently dead "Adding to cart…" button and no way
         back. That's the "gets stuck" report. */
      var resetButton = function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        document.removeEventListener('cart:change', resetButton);
        document.removeEventListener('cart:error', resetButton);
        self.el.atcBtn.disabled = false;
        self.el.atcBtn.textContent = ATC_LABEL;
      };

      this.el.atcBtn.disabled = true;
      /* Uploading the artwork is the slow part — on mobile data a large file
         can take a while — so name what's actually happening rather than
         letting it look frozen. */
      var hasFile = this.el.fileInput.files && this.el.fileInput.files.length;
      this.el.atcBtn.textContent = hasFile ? 'Uploading artwork…' : 'Adding to cart…';
      this.el.atcNote.textContent = '';

      /* Last-resort release. Better a retry than a button that never comes back. */
      timer = setTimeout(function () {
        if (settled) return;
        resetButton();
        self.el.atcNote.textContent = 'That is taking longer than usual — check your cart before trying again, in case it went through.';
      }, 45000);

      try {
        /* If a crop rebuild is still in flight, wait for it here. This is the
           one gate every path funnels through, so it closes the race regardless
           of which caller started the rebuild or whether that caller awaited it. */
        /* A design name typed on this step postdates the SVG built on the Size
           step. Regenerate before submitting so the label on the artboard
           matches the name on the order. Reassigns _artworkReady, so the await
           below covers it. */
        if (this._svgStale) this.refreshCroppedUpload();

        if (this._artworkReady) await this._artworkReady;

        var response = await fetch('/apps/pricer/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            width: this.state.w,
            height: this.state.h,
            qty: this.state.qty,
            /* The variant attaches to THIS real product rather than a shared
               internal container, so checkout's bold title is the actual
               product natively. Tradeoff, accepted deliberately: every
               generated variant lives on the real product's own variant list in
               admin. Flagged by Colin, 2026-08-13. */
            productId: this.dataset.productId
          })
        });
        var result = await response.json();
        if (!response.ok || !result.variantId) {
          throw new Error(result.error || 'Could not get a price for this configuration.');
        }

        var idField = this.form.querySelector('input[name="id"]');
        idField.value = result.variantId.split('/').pop();

        this.el.atcBtn.textContent = hasFile ? 'Uploading artwork…' : 'Adding to cart…';
        /* The backend creates this exact variant via the Admin API moments
           before handing it back. Confirmed live, 2026-08-12: Shopify's
           Storefront cart can still fail to find a variant that new with
           "Cannot find variant" even after the backend confirms the SAME
           variant is readable back through the Admin API — Admin and Storefront
           visibility propagate on separate timelines. This retry loop, hitting
           the real Storefront endpoint, is the only place that can observe when
           it's safe to proceed. */
        var retriesLeft = 6;
        var nextDelayMs = 1000;
        var cleanupCartListeners = function () {
          document.removeEventListener('cart:change', onAdded);
          self.form.removeEventListener('cart:error', onAddError);
        };
        var onAdded = function () {
          cleanupCartListeners();
          resetButton();
        };
        var onAddError = function (e) {
          cleanupCartListeners();
          if (settled) return;   // the 45s safety timeout already gave up
          var message = e.detail && e.detail.error;
          if (message === 'Cannot find variant' && retriesLeft > 0) {
            retriesLeft -= 1;
            self.el.atcBtn.textContent = 'Finalizing your price…';
            setTimeout(submitToCart, nextDelayMs);
            nextDelayMs = Math.min(nextDelayMs * 2, 5000);
            return;
          }
          resetButton();
          self.el.atcNote.textContent = "Couldn't add that to your cart — please try again.";
        };
        /* requestSubmit() runs the browser's OWN native constraint validation
           across every field in the form before it submits — including the size
           inputs, which are real <input type="number"> elements. Without
           step="any" a decimal like 4.25 counts as invalid, the browser
           silently blocks the submit and fires neither cart:change nor
           cart:error, and the button sits on "Uploading artwork…" until the 45s
           timeout. Caught live, 2026-08-12. */
        var submitToCart = function () {
          document.addEventListener('cart:change', onAdded, { once: true });
          self.form.addEventListener('cart:error', onAddError, { once: true });
          self.form.requestSubmit();
        };
        submitToCart();
      } catch (err) {
        resetButton();
        this.el.atcNote.textContent = "Couldn't get a price for this configuration — please try again.";
        console.error('[pricer] quote fetch failed:', err);
      }
    }

    /* Writes current state into the hidden line-item-property inputs right
       before the surrounding <product-form> submits.

       Artwork status is translated to a plain-English label here, at the
       boundary, rather than changing what the internal state holds — flagged by
       a client tester as "eliminate the coding language", 2026-08-12. */
    /* An optional field left blank still submits its key, so every order that
       skipped them showed bare "Project Details" and "Instagram" rows in admin
       with nothing after them. The cart already hides blank properties; admin
       deliberately shows everything, so the only way to keep it clean is not to
       send them. Dropping the `name` keeps the field out of the form post
       without touching what the customer typed; it is restored the moment they
       type into it again, so a failed submit can't lose the field. */
    dropBlankOptionalProps(){
      var self = this;
      ['dname', 'pinfo', 'ig'].forEach(function (role) {
        var el = self.querySelector('[data-role="' + role + '"]');
        if (!el) return;
        if (el.value && el.value.trim()) {
          if (el.dataset.propName) { el.name = el.dataset.propName; delete el.dataset.propName; }
        } else if (el.name) {
          el.dataset.propName = el.name;
          el.removeAttribute('name');
        }
      });
    }

    syncProperties(){
      this.dropBlankOptionalProps();
      /* "Inches" is spelled out in the value itself (not just implied by the
         property label) per Colin's exact requested format, 2026-08-12 — see
         line-item.liquid's extraction of pricer_width/pricer_height, which
         strips this suffix back off before building the customer-facing
         "15 × 10″" cart text, so it doesn't end up duplicated there. */
      if (this.el.propWidth) this.el.propWidth.value = this.state.w ? fmtDim(this.state.w) + ' Inches' : '';
      if (this.el.propHeight) this.el.propHeight.value = this.state.h ? fmtDim(this.state.h) + ' Inches' : '';
      /* fitMode 'unverified' means the customer ticked the acknowledgement for a
         file we couldn't rasterise, so nothing ever checked its proportions
         against the ordered size. That used to print as its own _Image Fit line;
         with that property gone (Colin, 2026-08-20) it rides on the status
         instead, because a bare "Uploaded" would let an unchecked file look
         identical to a cropped one on the production floor. 'crop' — every other
         uploaded order — stays plain "Uploaded"; there is no stretch path in v2
         for it to be distinguished from. */
      if (this.el.propArtStatus) {
        var artStatus = '';
        if (this.state.sendLater) {
          artStatus = 'Send later';
        } else if (this.state.artUploaded) {
          artStatus = this.state.fitMode === 'unverified' ? 'Uploaded (proportions not verified)' : 'Uploaded';
        }
        this.el.propArtStatus.value = artStatus;
      }
      if (this.el.qty) this.el.qty.value = this.state.qty;
    }
  }

  customElements.define('pricer-app-circle', PricerApp);
})();
